// Malayalam translations for the business management application
export default {
  // Landing page translations
  landing: {
    hero: {
      badge: 'ഇന്ത്യൻ SME-കൾക്കായി',
      title: 'നിങ്ങളുടെ ബിസിനസ്സ് നടത്തുക.',
      subtitle: 'പേപ്പർ വർക്ക് അല്ല.',
      description: 'ഇന്ത്യൻ SME-കൾക്കായി വരാനിരിക്കുന്ന എന്റർപ്രൈസ് OS. ലോക്കൽ-ഫസ്റ്റ് ലക്ഷ്വറിയോടെ GST, ഇൻവെന്ററി, ട്രേഡ് ഫിനാൻസ് എന്നിവ ലളിതമാക്കുക.',
      cta_waitlist: 'വെയ്റ്റ്‌ലിസ്റ്റിൽ ചേരുക',
      cta_demo: 'ആർക്കിടെക്ചർ കാണുക',
      trust_early: 'ഉടൻ തന്നെ ഏർലി ആക്സസ്',
      trust_card: 'ക്രെഡിറ്റ് കാർഡ് ആവശ്യമില്ല',
      trust_gst: 'GST ഫോക്കസ്',
      stats_revenue: 'വരുമാനം',
      stats_inventory: 'ഇൻവെന്ററി'
    },
    social_proof: {
      stats: {
        smes: { value: 'ഇന്ത്യൻ SME-കൾ', label: 'നിർമ്മിക്കുന്നത്' },
        gst: { value: 'GST ഫോക്കസ്', label: 'കംപ്ലയിൻസ്' },
        cloud: { value: 'ക്ലൗഡ് നേറ്റീവ്', label: 'ആർക്കിടെക്ചർ' },
        status: { value: 'ഏർലി ആക്സസ്', label: 'സ്റ്റാറ്റസ്' }
      }
    },
    problem: {
      badge: 'നിർണായക വെല്ലുവിളികൾ',
      title: 'നിങ്ങളുടെ വളർച്ചയെ',
      subtitle: 'തടയുന്ന ഘർഷണം.',
      description: "ആധുനിക ഇന്ത്യൻ ബിസിനസ്സ് ലാൻഡ്സ്കേപ്പ് അതിവേഗം വികസിച്ചുകൊണ്ടിരിക്കുന്നു. ഡിജിറ്റൽ കൊമേഴ്സിന്റെയും GST സങ്കീർണ്ണതയുടെയും വേഗതയ്ക്കായി ലെഗസി ടൂളുകൾ നിർമ്മിച്ചിട്ടില്ല.",
      cards: {
        paperwork: {
          title: 'പേപ്പർ വർക്കിൽ നഷ്ടപ്പെട്ട മണിക്കൂറുകൾ',
          description: 'മാനുവൽ ഇൻവോയ്സിംഗ്, ഡാറ്റ എൻട്രി, അനുരഞ്ജനം എന്നിവ ഓരോ ആഴ്ചയും 15+ മണിക്കൂർ ചിലവാക്കുന്നു. നിങ്ങൾ വളർച്ചയ്ക്കായി ചിലവഴിക്കേണ്ട സമയം.'
        },
        gst: {
          title: 'GST കംപ്ലയിൻസ് തലവേദനകൾ',
          description: 'ശരിയായ നികുതി നിരക്കുകൾ കണക്കാക്കുന്നത്, കൃത്യസമയത്ത് റിട്ടേണുകൾ ഫയൽ ചെയ്യുന്നത്, പിഴകൾ ഒഴിവാക്കുന്നത് എന്നിവ നിരന്തരമായ സാങ്കേതികവും മാനസികവുമായ ചോർച്ചയാണ്.'
        },
        inventory: {
          title: 'ഇൻവെന്ററി ബ്ലൈൻഡ് സ്പോട്ടുകൾ',
          description: "സ്റ്റോക്ക്ഔട്ടുകളും ഓവർസ്റ്റോക്കിംഗും സംഭവിക്കുന്നു, കാരണം നിങ്ങളുടെ മുഴുവൻ വെയർഹൗസ് നെറ്റ്‌വർക്കിലും നിങ്ങൾക്ക് തത്സമയ ദൃശ്യപരത ഇല്ല."
        }
      }
    },
    features: {
      title: 'എന്റർപ്രൈസ് പവർ.',
      subtitle: 'നിങ്ങൾക്കായി ലളിതമാക്കി.',
      description: 'ആധുനിക ബിസിനസ്സ് ഉടമയ്ക്കായി രൂപകൽപ്പന ചെയ്ത തടസ്സമില്ലാത്ത ഇന്റർഫേസുമായി സോമ ഇൻഡസ്ട്രിയൽ ഗ്രേഡ് അക്കൗണ്ടിംഗിനെ സംയോജിപ്പിക്കുന്നു.',
      cards: {
        invoicing: {
          title: 'GST ഇൻവോയ്സിംഗ്',
          description: 'സെക്കൻഡുകൾക്കുള്ളിൽ GST-കംപ്ലയിന്റ് ഇൻവോയ്സുകൾ സൃഷ്ടിക്കാൻ രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു. കൃത്യമായ പ്രാദേശിക കംപ്ലയിൻസിനൊപ്പം നികുതി നിരക്കുകൾ ഓട്ടോ-കണക്കാക്കുക.'
        },
        inventory: {
          title: 'ഇൻവെന്ററി സിങ്ക്',
          description: 'മൾട്ടി-സിറ്റി വെയർഹൗസുകളിൽ തത്സമയ സ്റ്റോക്ക് ലെവലുകൾ ട്രാക്ക് ചെയ്യുക. ഇൻവെന്ററി ആരോഗ്യത്തെക്കുറിച്ചുള്ള പ്രവചന അലേർട്ടുകൾ.'
        },
        intelligence: {
          title: 'ട്രേഡ് ഇന്റലിജൻസ്',
          description: 'ഞങ്ങളുടെ പ്രാദേശിക ആർക്കിടെക്ചർ ഉപയോഗിച്ച് സങ്കീർണ്ണമായ P&L, പണമൊഴുക്ക്, നികുതി റിപ്പോർട്ടുകൾ എന്നിവ സൃഷ്ടിക്കുക.'
        },
        mobile: {
          title: 'ഏകീകൃത മൊബൈൽ',
          description: 'നിങ്ങളുടെ ഫോണിൽ നിന്ന് നിങ്ങളുടെ മുഴുവൻ എന്റർപ്രൈസും നിയന്ത്രിക്കുക. എന്റർപ്രൈസ് പവർ, ഉപഭോക്തൃ ലാളിത്യം.'
        }
      },
      learn_more: 'കൂടുതൽ അറിയുക'
    },
    cta: {
      badge: 'പ്രീ-ലോഞ്ച് ആക്സസ്',
      title: 'ഭാവി',
      subtitle: 'ഇന്ത്യൻ വ്യാപാരം.',
      description: "സോമയുടെ എന്റർപ്രൈസ് ആർക്കിടെക്ചർ അനുഭവിക്കുന്ന ആദ്യത്തെ ആളുകളിൽ ഒരാളാകൂ. വേഗത, സ്കെയിൽ, പ്രാദേശിക കംപ്ലയിൻസ് എന്നിവയ്ക്കായി നിർമ്മിച്ചത്.",
      btn_waitlist: 'വെയ്റ്റ്‌ലിസ്റ്റിൽ ചേരുക',
      btn_features: 'ഫീച്ചറുകൾ കാണുക',
      benefits: {
        early_access: 'ഏർലി ആക്സസ്',
        priority: 'മുൻഗണന ഓൺബോർഡിംഗ്',
        updates: 'അപ്‌ഡേറ്റുകൾ ഉൾപ്പെടുത്തിയിട്ടുണ്ട്'
      }
    },
    differentiation: {
      badge: 'ഓമ്‌നിചാനൽ ആർക്കിടെക്ചർ',
      title: 'എവിടെനിന്നും',
      subtitle: 'വ്യാപാരം ചെയ്യുക.',
      description: 'ഉപഭോക്താവിനോട് സംസാരിക്കുമ്പോൾ നിങ്ങളുടെ ഫോണിൽ ഇൻവോയ്സ് ആരംഭിക്കാനും പിന്നീട് ലാപ്ടോപ്പിൽ പൂർത്തിയാക്കാനും രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു. കണക്റ്റിവിറ്റി കുറഞ്ഞ സ്ഥലങ്ങളിൽ പോലും എല്ലാ ഉപകരണങ്ങളിലും ഡാറ്റ തൽക്ഷണം സിങ്ക് ചെയ്യും.',
      items: {
        mobile: {
          title: 'മൊബൈൽ ഫസ്റ്റ്',
          desc: 'ഇന്ത്യൻ വിപണിയിലെ അതിവേഗ വ്യാപാരത്തിനായി തയ്യാറാക്കിയത്.'
        },
        desktop: {
          title: 'ഡെസ്ക്ടോപ്പ് സ്കെയിൽ',
          desc: 'വലിയ ഇൻവെന്ററി ഓപ്പറേഷനുകളും ബൾക്ക് ട്രേഡ് ക്ലിയറിംഗും.'
        },
        sync: {
          title: 'ഓഫ്‌ലൈൻ സിങ്ക്',
          desc: 'ഡാറ്റ പ്രാദേശികമായി സൂക്ഷിക്കുന്നു. കണക്റ്റ് ചെയ്താലുടൻ സിങ്ക് നടക്കുന്നു.'
        }
      },
      stats: {
        latency: { value: '< 1s', label: 'ടാർഗെറ്റ് ലേറ്റൻസി' },
        uptime: { value: '99.9%', label: 'ടാർഗെറ്റ് അപ്‌ടൈം' },
        crypto: { value: 'AES-256', label: 'ക്രിപ്റ്റോ' }
      },
      sync_status: 'ലൈവ് സിങ്ക്'
    },
    faq: {
      badge: 'വിജ്ഞാന അടിത്തറ',
      title: 'വിശദാംശങ്ങൾ',
      subtitle: 'വ്യക്തമാക്കുന്നു.',
      questions: {
        setup: {
          q: 'ലോഞ്ച് ചെയ്തുകഴിഞ്ഞാൽ സോമ സജ്ജീകരിക്കാൻ എത്ര സമയമെടുക്കും?',
          a: 'സോമ 2 മിനിറ്റിനുള്ളിൽ പൂർണ്ണമായി സജ്ജീകരിക്കാൻ രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു. നിങ്ങളുടെ ബിസിനസ്സ് പേരും GST നമ്പറും ചേർക്കുക, നിങ്ങൾക്ക് ഉടൻ തന്നെ ഇൻവോയ്സുകൾ സൃഷ്ടിക്കാൻ തുടങ്ങാം. Tally, Zoho അല്ലെങ്കിൽ സ്പ്രെഡ്‌ഷീറ്റുകളിൽ നിന്ന് സൗജന്യ മൈഗ്രേഷൻ സഹായം നൽകാനും ഞങ്ങൾ പദ്ധതിയിടുന്നു.'
        },
        security: {
          q: 'എന്റെ ബിസിനസ്സ് ഡാറ്റ സുരക്ഷിതമാണോ?',
          a: 'തീർച്ചയായും. എല്ലാ ഡാറ്റയ്ക്കും ബാങ്ക്-ഗ്രേഡ് 256-ബിಟ್ എൻക്രിപ്ഷൻ ഞങ്ങൾ നടപ്പിലാക്കുന്നു. നിങ്ങളുടെ വിവരങ്ങൾ ഒന്നിലധികം ബാക്കപ്പുകളോടെ ഇന്ത്യയിലെ സുരക്ഷിത സെർവറുകളിൽ സൂക്ഷിക്കും. ഞങ്ങൾ ISO 27001 സാക്ഷ്യപ്പെടുത്തിയതും പൂർണ്ണമായും DPDP അനുസരിച്ചുള്ളതുമായി നിർമ്മിക്കുന്നു.'
        },
        knowledge: {
          q: 'എനിക്ക് അക്കൗണ്ടിംഗ് അല്ലെങ്കിൽ സാങ്കേതിക അറിവ് ആവശ്യമുണ്ടോ?',
          a: 'ഒരിക്കലുമില്ല. സോമ ബിസിനസ്സ് ഉടമകൾക്കായി രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു, അക്കൗണ്ടന്റുകൾക്കല്ല. നിങ്ങൾക്ക് വാട്ട്‌സ്ആപ്പ് ഉപയോഗിക്കാൻ കഴിയുമെങ്കിൽ, നിങ്ങൾക്ക് സോമ ഉപയോഗിക്കാൻ കഴിയും. സങ്കീർണ്ണമായ എല്ലാ GST കണക്കുകൂട്ടലുകളും, നികുതി വർഗ്ഗീകരണങ്ങളും, കംപ്ലയിൻസ് ആവശ്യകതകളും ഞങ്ങൾ സ്വയമേവ കൈകാര്യം ചെയ്യുന്നു.'
        },
        offline: {
          q: 'എനിക്ക് ഇന്റർനെറ്റ് കണക്ഷൻ ഇല്ലെങ്കിൽ എന്ത് സംഭവിക്കും?',
          a: 'സോമ ഓഫ്‌ലൈനിലും പ്രവർത്തിക്കാൻ രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു. ഞങ്ങളുടെ മൊബൈൽ ആപ്പിൽ നിങ്ങൾക്ക് ഇൻവോയ്സുകൾ സൃഷ്ടിക്കാനും ഇൻവെന്ററി അപ്‌ഡേറ്റ് ചെയ്യാനും വിൽപ്പന രേഖപ്പെടുത്താനും തുടരാം. നിങ്ങൾ ഓൺലൈനിൽ തിരിച്ചെത്തിയാലുടൻ, എല്ലാം നിങ്ങളുടെ എല്ലാ ഉപകരണങ്ങളിലും സ്വയമേവ സിങ്ക് ചെയ്യും.'
        },
        migration: {
          q: 'Tally-ൽ നിന്ന് എന്റെ നിലവിലുള്ള ഡാറ്റ മൈഗ്രേറ്റ് ചെയ്യാൻ കഴിയുമോ?',
          a: 'അതെ! Tally, Zoho Books അല്ലെങ്കിൽ Excel സ്പ്രെഡ്‌ഷീറ്റുകളിൽ നിന്ന് നിങ്ങളുടെ ഉപഭോക്തൃ ഡാറ്റ, ഉൽപ്പന്ന കാറ്റലോഗ്, ചരിത്രപരമായ ഇടപാടുകൾ എന്നിവ തടസ്സമില്ലാതെ കൈകാര്യം ചെയ്യാൻ ഞങ്ങൾ ഇമ്പോർട്ട് ടൂളുകൾ നിർമ്മിക്കുന്നു.'
        }
      },
      cta: {
        title: 'ആർക്കിടെക്ചറൽ സപ്പോർട്ട്',
        link: 'ഞങ്ങളുടെ എഞ്ചിനീയർമാരെ ബന്ധപ്പെടുക'
      }
    },
    testimonials: {
      badge: 'ഞങ്ങളുടെ ശ്രദ്ധ',
      title: 'ഓരോ ഇന്ത്യൻ ബിസിനസ്സിനും',
      subtitle: 'വേണ്ടി രൂപകൽപ്പന ചെയ്യുന്നു.',
      description: 'മൊത്തക്കച്ചവടക്കാർ മുതൽ നിർമ്മാതാക്കൾ വരെ, നിങ്ങളുടെ തനതായ വ്യാപാര ആവശ്യങ്ങൾക്ക് അനുയോജ്യമായ രീതിയിൽ സോമ രൂപകൽപ്പന ചെയ്യുന്നു.',
      featured: {
        title: 'മൊത്തവ്യാപാരവും വിതരണവും',
        description: 'ബൾക്ക് ഇൻവെന്ററി, സങ്കീർണ്ണമായ വിലനിർണ്ണയ നിരക്കുകൾ, ക്രെഡിറ്റ് സൈക്കിളുകൾ എന്നിവ എളുപ്പത്തിൽ കൈകാര്യം ചെയ്യുക. സോമ വോളിയം കൈകാര്യം ചെയ്യാൻ നിർമ്മിച്ചതാണ്, അതിനാൽ നിങ്ങൾക്ക് വ്യാപാരത്തിൽ ശ്രദ്ധ കേന്ദ്രീകരിക്കാം.',
        badge: {
          title: 'മൊത്തവ്യാപാരം',
          desc: 'ഉയർന്ന വോളിയം • കുറഞ്ഞ മാർജിൻ'
        },
        stats: {
          inventory: { label: 'ഇൻവെന്ററി', value: 'ബാച്ച് ട്രാക്കിംഗ്' },
          pricing: { label: 'വില', value: 'മൾട്ടി-ടയർ' },
          finance: { label: 'ഫിനാൻസ്', value: 'ക്രെഡിറ്റ് മാനേജ്മെന്റ്' }
        }
      },
      industries: {
        manufacturing: {
          title: 'നിർമ്മാണം',
          description: 'അസംസ്കൃത വസ്തുക്കൾ, ബിൽ ഓഫ് മെറ്റീരിയൽസ് (BOM), ഉൽപാദനച്ചെലവ് എന്നിവയുടെ കൃത്യമായ ട്രാക്കിംഗ് ലക്ഷ്യമിടുന്നു.'
        },
        retail: {
          title: 'റീട്ടെയിൽ ചെയിനുകൾ',
          description: 'ആസൂത്രിതമായ യൂണിഫൈഡ് പോയിന്റ് ഓഫ് സെയിൽ (POS), ബാർകോഡ് സ്കാനിംഗ്, തത്സമയ മൾട്ടി-സ്റ്റോർ സിൻക്രൊണൈസേഷൻ.'
        },
        service: {
          title: 'സേവന ദാതാക്കൾ',
          description: 'പ്രോജക്റ്റ് അധിഷ്ഠിത ബില്ലിംഗ്, ടൈം ട്രാക്കിംഗ്, ഓട്ടോമേറ്റഡ് ചെലവ് മാനേജ്മെന്റ് എന്നിവയ്ക്കായി രൂപകൽപ്പന ചെയ്തിരിക്കുന്നു.'
        }
      }
    },
    pricing_page: {
      badge: 'സുതാര്യമായ വില',
      title: 'ലളിതമായ സ്കെയിൽ.',
      subtitle: 'സങ്കീർണ്ണതയില്ല.',
      description: 'നിങ്ങളുടെ ബിസിനസ്സ് വളർത്താൻ അനുയോജ്യമായ പ്ലാൻ തിരഞ്ഞെടുക്കുക. സുതാര്യത, സമത്വം, പ്രാദേശിക-ആദ്യ ആർക്കിടെക്ചർ എന്നിവയ്ക്കായി സമർപ്പിക്കുന്നു.',
      billing: {
        monthly: 'പ്രതിമാസം',
        yearly: 'പ്രതിവർഷം',
        save: '20% ലാഭിക്കുക'
      },
      yearly_discount: 'വാർഷിക കിഴിവ്',
      per_month: '/മാസം',
      plans: {
        features_title: 'ഉൾപ്പെടുത്തിയ ഫീച്ചറുകൾ',
        per_month: '/മാസം',
        recommended: 'സ്കെയിലിനായി ശുപാർശ ചെയ്യുന്നു',
        starter: {
          name: 'സ്റ്റാർട്ടർ',
          description: 'ചെറുകിട ബിസിനസ്സുകൾക്കും വളരുന്ന സ്റ്റാർട്ടപ്പുകൾക്കും അനുയോജ്യം',
          cta: 'വെയ്റ്റ്‌ലിസ്റ്റിൽ ചേരുക',
          features: {
            invoices: 'പ്രതിമാസം 100 ഇൻവോയ്സുകൾ വരെ',
            gst: 'അടിസ്ഥാന ജിഎസ്ടി പാലിക്കൽ',
            inventory: 'ഒറ്റ ലൊക്കേഷൻ ഇൻവെന്ററി',
            support: 'ഇമെയിൽ പിന്തുണ',
            reporting: 'അടിസ്ഥാന റിപ്പോർട്ടിംഗ്',
            mobile: 'മൊബൈൽ ആപ്പ് ആക്സസ്'
          }
        },
        professional: {
          name: 'പ്രൊഫഷണൽ',
          description: 'സങ്കീർണ്ണമായ ആവശ്യങ്ങളുള്ള വളരുന്ന ബിസിനസ്സുകൾക്ക് അനുയോജ്യം',
          cta: 'വെയ്റ്റ്‌ലിസ്റ്റിൽ ചേരുക',
          features: {
            invoices: 'പരിധിയില്ലാത്ത ഇൻവോയ്സുകൾ',
            gst: 'വിപുലമായ ജിഎസ്ടി പാലിക്കൽ',
            inventory: 'മൾട്ടി-ലൊക്കേഷൻ ഇൻവെന്ററി',
            support: 'മുൻഗണനാ പിന്തുണ',
            analytics: 'വിപുലമായ അനലിറ്റിക്സ്',
            api: 'API ആക്സസ്',
            integrations: 'കസ്റ്റം ഇന്റഗ്രേഷനുകൾ',
            users: 'മൾട്ടി-യൂസർ ആക്സസ്'
          }
        },
        enterprise: {
          name: 'എന്റർപ്രൈസ്',
          description: 'ടീം വർക്ക്ഫ്ലോകളുള്ള വൻകിട ബിസിനസ്സുകൾക്കായി',
          cta: 'നേരത്തെയുള്ള ആക്സസിനായി ബന്ധപ്പെടുക',
          features: {
            all_pro: 'പ്രൊഫഷണലിലെ എല്ലാം',
            manager: 'പ്രത്യേക അക്കൗണ്ട് മാനേജർ',
            workflows: 'കസ്റ്റം വർക്ക്ഫ്ലോകൾ',
            security: 'വിപുലമായ സുരക്ഷാ സവിശേഷതകൾ',
            whitelabel: 'വൈറ്റ്-ലേബൽ ഓപ്ഷനുകൾ',
            access: 'റോൾ അടിസ്ഥാനമാക്കിയുള്ള ആക്സസ്',
            reporting: 'കസ്റ്റം റിപ്പോർട്ടിംഗ്',
            deployment: 'ഓൺ-പ്രെമിസ് വിന്യാസം'
          }
        }
      }
    },
    final_cta: {
      title: 'തയ്യാറാണോ',
      subtitle: 'വലിയ സ്കെയിലിനായി?',
      book_call: 'ആർക്കിടെക്ചർ കോൾ ബുക്ക് ചെയ്യുക',
      contact_sales: 'വിൽപ്പന വിഭാഗവുമായി ബന്ധപ്പെടുക',
      footer: 'സോമ വിന്യസിക്കുക. പാരമ്പര്യം നിർമ്മിക്കുക.'
    },
    solutions_page: {
      badge: 'വ്യവസായ നിർദ്ദിഷ്ട DNA',
      title: 'കസ്റ്റം മെയ്ഡ്',
      subtitle: 'നിങ്ങളുടെ സ്കെയിലിനായി.',
      description: 'ജനറിക് സോഫ്റ്റ്‌വെയർ പരാജയപ്പെടുന്നു കാരണം നിങ്ങളുടെ ബിസിനസ്സ് സവിശേഷമാണ്. സോമ നിങ്ങളുടെ വ്യവസായ നിർദ്ദിഷ്ട വർക്ക്ഫ്ലോകളുമായി പൊരുത്തപ്പെടുന്നു.',
      cta_contact: 'വിൽപ്പന വിഭാഗവുമായി ബന്ധപ്പെടുക',
      cta_case_studies: 'കേസ് സ്റ്റഡീസ് കാണുക',
      core_workflow: 'കോർ വർക്ക്ഫ്ലോ ഘടകങ്ങൾ',
      top_users: 'മുൻനിര വ്യവസായ ഉപയോക്താക്കൾ',
      validated_results: 'അംഗീകൃത ഫലങ്ങൾ',
      deployment: 'എന്റർപ്രൈസ് വിന്യാസം',
      built_for_scale: 'സങ്കീർണ്ണമായ ഇന്ത്യൻ സ്കെയിലിനായി നിർമ്മിച്ചത്.',
      industries: {
        retail: {
          title: 'Retail & E-commerce',
          description: 'ഏകീകൃത ഇൻവെന്ററിയും മൾട്ടി-ചാനൽ ബില്ലിംഗും ഉപയോഗിച്ച് നിങ്ങളുടെ റീട്ടെയിൽ ബിസിനസ്സ് സ്കെയിൽ ചെയ്യുക.',
          features: {
            inventory: 'മൾട്ടി-ചാനൽ ഇൻവെന്ററി സിങ്ക്',
            pos: 'പോയിന്റ് ഓഫ് സെയിൽ (POS) ഇന്റഗ്രേഷൻ',
            loyalty: 'ലോയൽറ്റി & ഗിഫ്റ്റ് കാർഡുകൾ',
            reordering: 'ഓട്ടോമേറ്റഡ് സ്റ്റോക്ക് റീഓർഡറിംഗ്'
          },
          tags: {
            fashion: 'ഫാഷൻ',
            electronics: 'ഇലക്ട്രോണിക്സ്',
            chains: 'റീട്ടെയിൽ ചെയിനുകൾ'
          },
          proof: {
            label: 'സ്റ്റോക്ക്ഔട്ട് കുറയ്ക്കൽ',
            company: 'ഫാഷൻ റീട്ടെയിൽ'
          }
        },
        manufacturing: {
          title: 'Manufacturing',
          description: 'സ്മാർട്ട് കോസ്റ്റ് ട്രാക്കിംഗും അസംസ്കൃത വസ്തുക്കളുടെ വർക്ക്ഫ്ലോകളും ഉപയോഗിച്ച് ഉൽപ്പാദനം ഒപ്റ്റിമൈസ് ചെയ്യുക.',
          features: {
            planning: 'പ്രൊഡക്ഷൻ പ്ലാനിംഗ് (MRP)',
            bom: 'BOM മാനേജ്മെന്റ്',
            waste: 'വേസ്റ്റ് & സ്ക്രാപ്പേജ് ട്രാക്കിംഗ്',
            labor: 'ലേബർ കോസ്റ്റ് ആട്രിബ്യൂഷൻ'
          },
          tags: {
            auto: 'ഓട്ടോ പാർട്സ്',
            textile: 'ടെക്സ്റ്റൈൽ മിൽസ്',
            food: 'ഫുഡ് ടെക്'
          },
          proof: {
            label: 'വേസ്റ്റ് കുറയ്ക്കൽ',
            company: 'മാനുഫാക്ചറിംഗ്'
          }
        },
        services: {
          title: 'Services & Agencies',
          description: 'ക്ലയന്റ് ബില്ലിംഗും പ്രോജക്റ്റ് ലാഭക്ഷമതയും എളുപ്പമാക്കുക.',
          features: {
            accounting: 'പ്രോജക്റ്റ് അടിസ്ഥാനമാക്കിയുള്ള അക്കൗണ്ടിംഗ്',
            portal: 'പേയ്മെന്റുകൾക്കുള്ള ക്ലയന്റ് പോർട്ടൽ',
            tracking: 'ഇൻവോയ്സിനുള്ള സമയം ട്രാക്കിംഗ്',
            billing: 'ആവർത്തിച്ചുള്ള സേവന ബില്ലിംഗ്'
          },
          tags: {
            it: 'IT ഏജൻസികൾ',
            law: 'നിയമ സ്ഥാപനങ്ങൾ',
            consulting: 'കൺസൾട്ടിംഗ്'
          },
          proof: {
            label: 'വേഗത്തിലുള്ള ബില്ലിംഗ്',
            company: 'സർവീസ് ഏജൻസി'
          }
        },
        healthcare: {
          title: 'Healthcare',
          description: 'മെഡിക്കൽ പ്രാക്ടീസുകൾക്കും ലാബുകൾക്കും വേണ്ടിയുള്ള കംപ്ലയിൻസ്-റെഡി ബാക്ക്-ഓഫീസ് ടൂളുകൾ.',
          features: {
            inventory: 'മെഡിക്കൽ ഇൻവെന്ററി നിയന്ത്രണം',
            claims: 'ഇൻഷുറൻസ് ക്ലെയിം ട്രാക്കിംഗ്',
            billing: 'രോഗി ബില്ലിംഗ് ഓട്ടോമേഷൻ',
            reporting: 'റെഗുലേറ്ററി റിപ്പോർട്ടിംഗ്'
          },
          tags: {
            clinics: 'ക്ലിനിക്കുകൾ',
            pharmacies: 'ഫാർമസികൾ',
            labs: 'ലാബുകൾ'
          },
          proof: {
            label: 'ബില്ലിംഗ് കൃത്യത',
            company: 'ഹെൽത്ത് കെയർ'
          }
        }
      },
      cta_section: {
        title_prefix: 'നിങ്ങളുടെ',
        title_suffix: 'സൊല്യൂഷൻ DNA കണ്ടെത്താൻ തയ്യാറാണോ?',
        book_audit: 'ആർക്കിടെക്ചർ ഓഡിറ്റ് ബുക്ക് ചെയ്യുക',
        talk_expert: 'വിദഗ്ദ്ധനോട് സംസാരിക്കുക',
        footer_text: 'പ്രാദേശികമായി വിന്യസിക്കുക. ആഗോളതലത്തിൽ വളരുക.'
      }
    },
    resources_page: {
      badge: 'സോമ നോളജ് ഹബ്',
      title_prefix: 'പഠിക്കുക',
      title_suffix: 'വളരുക',
      description: 'ഒരു അജയ്യമായ ഇന്ത്യൻ SME നിർമ്മിക്കാൻ നിങ്ങളെ സഹായിക്കുന്ന എക്സ്ക്ലൂസീവ് ഗൈഡുകൾ, വ്യവസായ ഉൾക്കാഴ്ചകൾ, സാങ്കേതിക രേഖകൾ.',
      ledger: {
        title: 'ദി ലെഡ്ജർ',
        subtitle: 'SME സ്കെയിൽ, ലോക്കൽ-ഫസ്റ്റ് ആർക്കിടെക്ചർ എന്നിവയെക്കുറിച്ചുള്ള ഒരു പത്രിക.',
        cta: 'ശേഖരം പര്യവേക്ഷണം ചെയ്യുക'
      },
      implementation: {
        title_prefix: 'നടപ്പിലാക്കൽ',
        title_suffix: 'നൈപുണ്യം',
        description: 'ഞങ്ങളുടെ ആർക്കിടെക്റ്റുകൾ വലിയ തോതിലുള്ള എന്റർപ്രൈസ് വിന്യാസങ്ങൾക്കും കസ്റ്റം നിർമ്മാണ വർക്ക്ഫ്ലോകൾക്കുമായി സമർപ്പിത സെഷനുകൾ നൽകുന്നു.',
        cta_training: 'പരിശീലനം ഷെഡ്യൂൾ ചെയ്യുക',
        cta_support: 'സാങ്കേതിക പിന്തുണ',
        footer: 'ആർക്കിടെക്ചർ • ഇന്റഗ്രേഷൻ • സ്കെയിൽ'
      },
      cards: {
        quick_start: {
          title: "ദ്രുത ആരംഭ ഗൈഡ്",
          description: "10 മിനിറ്റിനുള്ളിൽ സോമയുമായുള്ള നിങ്ങളുടെ യാത്ര ആരംഭിക്കാൻ ആവശ്യമായതെല്ലാം.",
          tag: "അത്യാവശ്യം"
        },
        mastering_gst: {
          title: "GST നൈപുണ്യം",
          description: "GSTR ഓട്ടോമേഷൻ, ഇ-വേ ബില്ലുകൾ, പ്രാദേശിക നികുതി പാലിക്കൽ എന്നിവയെക്കുറിച്ചുള്ള ആഴത്തിലുള്ള പഠനം.",
          tag: "അപ്ഡേറ്റ് ചെയ്തത് 2026"
        },
        inventory_strategy: {
          title: "ഇൻവെന്ററി തന്ത്രം",
          description: "സോമയുടെ മൾട്ടി-ലൊക്കേഷൻ സിങ്ക് ഉപയോഗിച്ച് വി.കെ. പ്രിന്റ്സ് എങ്ങനെ 400% വളർച്ച കൈവരിച്ചു.",
          tag: "കേസ് സ്റ്റഡി"
        },
        api_docs: {
          title: "API ഡോക്യുമെന്റേഷൻ",
          description: "കസ്റ്റം ഇന്റഗ്രേഷനുകൾ നിർമ്മിക്കുകയും സോമയുടെ കഴിവുകൾ വിപുലീകരിക്കുകയും ചെയ്യുക.",
          tag: "സാങ്കേതികം"
        },
        community: {
          title: "കമ്മ്യൂണിറ്റി ഫോറം",
          description: "മറ്റ് ബിസിനസ്സ് ഉടമകളുമായും സോമ വിദഗ്ധരുമായും ബന്ധപ്പെടുക.",
          tag: "പുറമെയുള്ളത്"
        },
        webinar: {
          title: "വെബിനാർ: GST 2026",
          description: "പുതിയ നികുതി നിയമങ്ങളെക്കുറിച്ചുള്ള ഞങ്ങളുടെ ഏറ്റവും പുതിയ സെഷന്റെ റെക്കോർഡിംഗ് കാണുക.",
          tag: "പുതിയത്"
        }
      }
    },
  // Layout translations
  layout: {
    navbar: {
      login: 'ലോഗിൻ',
      get_started: 'ആരംഭിക്കുക',
      dashboard: 'ഡാഷ്ബോർഡ്',
      links: {
        features: 'ഫീച്ചറുകൾ',
        pricing: 'വില',
        solutions: 'പരിഹാരങ്ങൾ',
        resources: 'വിഭവങ്ങൾ'
      }
    },
    footer: {
      brand_desc: 'ഇന്ത്യൻ എന്റർപ്രൈസസിന്റെ സ്കെയിലിനായി എൻജിനീയറിംഗ് ചെയ്ത പ്രീമിയം ബിസിനസ്സ് ഓപ്പറേറ്റിംഗ് സിസ്റ്റം.',
      engineered_for: 'എൻജിനീയർ ചെയ്തത്',
      excellence: 'മികവ്',
      sections: {
        product: 'ഉൽപ്പന്നം',
        company: 'കമ്പനി',
        resources: 'വിഭവങ്ങൾ',
        legal: 'നിയമപരമായ'
      },
      links: {
        features: 'ഫീച്ചറുകൾ',
        pricing: 'വില',
        solutions: 'പരിഹാരങ്ങൾ',
        resources: 'വിഭവങ്ങൾ',
        about: 'കുറിച്ച്',
        blog: 'ബ്ലോഗ്',
        careers: 'കരിയറുകൾ',
        contact: 'ബന്ധപ്പെടുക',
        docs: 'ഡോക്യുമെന്റേഷൻ',
        help: 'സഹായ കേന്ദ്രം',
        api: 'API റഫറൻസ്',
        status: 'സ്റ്റാറ്റസ്',
        privacy: 'സ്വകാര്യത',
        terms: 'വ്യവസ്ഥകൾ',
        security: 'സുരക്ഷ'
      },
      copyright: 'സോമ ടെക്നോളജീസ്. എല്ലാ അവകാശങ്ങളും നിക്ഷിപ്തം.'
    }
  },
  // Common UI elements
  common: {
    loading: 'ലോഡ് ചെയ്യുന്നു...',
    save: 'സേവ് ചെയ്യുക',
    cancel: 'റദ്ദാക്കുക',
    delete: 'ഇല്ലാതാക്കുക',
    edit: 'എഡിറ്റ് ചെയ്യുക',
    add: 'ചേർക്കുക',
    create: 'സൃഷ്ടിക്കുക',
    update: 'അപ്ഡേറ്റ് ചെയ്യുക',
    search: 'തിരയുക',
    filter: 'ഫിൽട്ടർ',
    export: 'എക്സ്പോർട്ട്',
    import: 'ഇമ്പോർട്ട്',
    print: 'പ്രിന്റ്',
    download: 'ഡൗൺലോഡ്',
    upload: 'അപ്ലോഡ്',
    submit: 'സമർപ്പിക്കുക',
    reset: 'റീസെറ്റ്',
    clear: 'ക്ലിയർ',
    confirm: 'സ്ഥിരീകരിക്കുക',
    yes: 'അതെ',
    no: 'ഇല്ല',
    ok: 'ശരി',
    close: 'അടയ്ക്കുക',
    back: 'പിന്നിലേക്ക്',
    next: 'അടുത്തത്',
    previous: 'മുമ്പത്തെ',
    finish: 'പൂർത്തിയാക്കുക',
    continue: 'തുടരുക',
    skip: 'ഒഴിവാക്കുക',
    retry: 'വീണ്ടും ശ്രമിക്കുക',
    refresh: 'റിഫ്രഷ്',
    view: 'കാണുക',
    details: 'വിശദാംശങ്ങൾ',
    settings: 'സെറ്റിംഗുകൾ',
    help: 'സഹായം',
    about: 'കുറിച്ച്',
    contact: 'ബന്ധപ്പെടുക',
    support: 'പിന്തുണ',
    feedback: 'ഫീഡ്ബാക്ക്',
    logout: 'ലോഗ് ഔട്ട്',
    login: 'ലോഗിൻ',
    register: 'രജിസ്റ്റർ',
    profile: 'പ്രൊഫൈൽ',
    account: 'അക്കൗണ്ട്',
    dashboard: 'ഡാഷ്ബോർഡ്',
    home: 'ഹോം',
    menu: 'മെനു',
    navigation: 'നാവിഗേഷൻ',
    sidebar: 'സൈഡ്ബാർ',
    header: 'ഹെഡർ',
    footer: 'ഫൂട്ടർ',
    content: 'ഉള്ളടക്കം',
    main: 'പ്രധാന',
    section: 'വിഭാഗം',
    page: 'പേജ്',
    tab: 'ടാബ്',
    panel: 'പാനൽ',
    modal: 'മോഡൽ',
    dialog: 'ഡയലോഗ്',
    form: 'ഫോം',
    field: 'ഫീൽഡ്',
    input: 'ഇൻപുട്ട്',
    select: 'തിരഞ്ഞെടുക്കുക',
    option: 'ഓപ്ഷൻ',
    checkbox: 'ചെക്ക്ബോക്സ്',
    radio: 'റേഡിയോ',
    button: 'ബട്ടൺ',
    link: 'ലിങ്ക്',
    image: 'ചിത്രം',
    icon: 'ഐക്കൺ',
    text: 'ടെക്സ്റ്റ്',
    title: 'ശീർഷകം',
    description: 'വിവരണം',
    name: 'പേര്',
    email: 'ഇമെയിൽ',
    phone: 'ഫോൺ',
    address: 'വിലാസം',
    city: 'നഗരം',
    state: 'സംസ്ഥാനം',
    country: 'രാജ്യം',
    zipcode: 'പിൻ കോഡ്',
    date: 'തീയതി',
    time: 'സമയം',
    datetime: 'തീയതിയും സമയവും',
    status: 'സ്റ്റാറ്റസ്',
    type: 'തരം',
    category: 'വിഭാഗം',
    priority: 'മുൻഗണന',
    quantity: 'അളവ്',
    price: 'വില',
    amount: 'തുക',
    total: 'ആകെ',
    subtotal: 'ഉപ ആകെ',
    tax: 'നികുതി',
    discount: 'കിഴിവ്',
    currency: 'കറൻസി',
    unit: 'യൂണിറ്റ്',
    notes: 'കുറിപ്പുകൾ',
    comments: 'കമന്റുകൾ',
    tags: 'ടാഗുകൾ',
    actions: 'പ്രവർത്തനങ്ങൾ',
    options: 'ഓപ്ഷനുകൾ',
    preferences: 'മുൻഗണനകൾ',
    configuration: 'കോൺഫിഗറേഷൻ',
    advanced: 'വിപുലമായ',
    basic: 'അടിസ്ഥാന',
    general: 'പൊതുവായ',
    security: 'സുരക്ഷ',
    privacy: 'സ്വകാര്യത',
    notifications: 'അറിയിപ്പുകൾ',
    alerts: 'അലേർട്ടുകൾ',
    warnings: 'മുന്നറിയിപ്പുകൾ',
    errors: 'പിശകുകൾ',
    success: 'വിജയം',
    info: 'വിവരം',
    tips: 'നുറുങ്ങുകൾ',
    guides: 'ഗൈഡുകൾ',
    tutorials: 'ട്യൂട്ടോറിയലുകൾ',
    documentation: 'ഡോക്യുമെന്റേഷൻ',
    faq: 'പതിവായി ചോദിക്കുന്ന ചോദ്യങ്ങൾ',
    terms: 'നിബന്ധനകൾ',
    conditions: 'വ്യവസ്ഥകൾ',
    policy: 'നയം',
    agreement: 'കരാർ',
    license: 'ലൈസൻസ്',
    version: 'പതിപ്പ്',
    active: 'സജീവം',
    inactive: 'നിഷ്ക്രിയം',
    pending: 'തീർപ്പുകൽപ്പിക്കാത്ത',
    completed: 'പൂർത്തിയായി',
    failed: 'പരാജയപ്പെട്ടു',
    cancelled: 'റദ്ദാക്കി',
    approved: 'അംഗീകരിച്ചു',
    rejected: 'നിരസിച്ചു',
    draft: 'ഡ്രാഫ്റ്റ്',
    published: 'പ്രസിദ്ധീകരിച്ചു',
    archived: 'ആർക്കൈവ് ചെയ്തു',
    deleted: 'ഇല്ലാതാക്കി',
    new: 'പുതിയ',
    old: 'പഴയ',
    recent: 'സമീപകാല',
    latest: 'ഏറ്റവും പുതിയ',
    popular: 'ജനപ്രിയ',
    featured: 'ഫീച്ചർ ചെയ്ത',
    recommended: 'ശുപാർശ ചെയ്ത',
    trending: 'ട്രെൻഡിംഗ്',
    high: 'ഉയർന്ന',
    medium: 'ഇടത്തരം',
    low: 'കുറഞ്ഞ',
    urgent: 'അടിയന്തിര',
    normal: 'സാധാരണ',
    critical: 'നിർണായക',
    important: 'പ്രധാനപ്പെട്ട',
    optional: 'ഓപ്ഷണൽ',
    required: 'ആവശ്യമായ',
    mandatory: 'നിർബന്ധിത',
    public: 'പൊതു',
    private: 'സ്വകാര്യ',
    shared: 'പങ്കിട്ട',
    personal: 'വ്യക്തിഗത',
    business: 'ബിസിനസ്',
    professional: 'പ്രൊഫഷണൽ',
    enterprise: 'എന്റർപ്രൈസ്',
    premium: 'പ്രീമിയം',
    free: 'സൗജന്യ',
    paid: 'പണമടച്ച',
    trial: 'ട്രയൽ',
    demo: 'ഡെമോ',
    beta: 'ബീറ്റ',
    alpha: 'ആൽഫ',
    stable: 'സ്ഥിരമായ',
    development: 'വികസനം',
    production: 'ഉൽപ്പാദനം',
    testing: 'പരീക്ഷണം',
    staging: 'സ്റ്റേജിംഗ്',
    maintenance: 'പരിപാലനം',
    backup: 'ബാക്കപ്പ്',
    restore: 'പുനഃസ്ഥാപിക്കുക',
    sync: 'സിങ്ക്',
    migrate: 'മൈഗ്രേറ്റ്',
    transfer: 'കൈമാറ്റം',
    copy: 'കോപ്പി',
    move: 'നീക്കുക',
    duplicate: 'ഡ്യൂപ്ലിക്കേറ്റ്',
    clone: 'ക്ലോൺ',
    merge: 'മെർജ്',
    split: 'വിഭജിക്കുക',
    combine: 'സംയോജിപ്പിക്കുക',
    separate: 'വേർതിരിക്കുക',
    group: 'ഗ്രൂപ്പ്',
    ungroup: 'അൺഗ്രൂപ്പ്',
    sort: 'സോർട്ട്',
    order: 'ഓർഡർ',
    arrange: 'ക്രമീകരിക്കുക',
    organize: 'സംഘടിപ്പിക്കുക',
    manage: 'കൈകാര്യം ചെയ്യുക',
    control: 'നിയന്ത്രണം',
    monitor: 'മോണിറ്റർ',
    track: 'ട്രാക്ക്',
    analyze: 'വിശകലനം ചെയ്യുക',
    report: 'റിപ്പോർട്ട്',
    statistics: 'സ്ഥിതിവിവരക്കണക്കുകൾ',
    metrics: 'മെട്രിക്സ്',
    analytics: 'അനലിറ്റിക്സ്',
    insights: 'ഉൾക്കാഴ്ചകൾ',
    trends: 'ട്രെൻഡുകൾ',
    patterns: 'പാറ്റേണുകൾ',
    data: 'ഡാറ്റ',
    information: 'വിവരം',
    content: 'ഉള്ളടക്കം',
    media: 'മീഡിയ',
    files: 'ഫയലുകൾ',
    documents: 'ഡോക്യുമെന്റുകൾ',
    images: 'ചിത്രങ്ങൾ',
    videos: 'വീഡിയോകൾ',
    audio: 'ഓഡിയോ',
    attachments: 'അറ്റാച്ച്മെന്റുകൾ',
    downloads: 'ഡൗൺലോഡുകൾ',
    uploads: 'അപ്ലോഡുകൾ',
    storage: 'സ്റ്റോറേജ്',
    memory: 'മെമ്മറി',
    cache: 'കാഷ്',
    database: 'ഡാറ്റാബേസ്',
    server: 'സർവർ',
    client: 'ക്ലയന്റ്',
    network: 'നെറ്റ്വർക്ക്',
    internet: 'ഇന്റർനെറ്റ്',
    connection: 'കണക്ഷൻ',
    bandwidth: 'ബാൻഡ്വിഡ്ത്',
    speed: 'വേഗത',
    performance: 'പ്രകടനം',
    optimization: 'ഒപ്റ്റിമൈസേഷൻ',
    efficiency: 'കാര്യക്ഷമത',
    quality: 'ഗുണനിലവാരം',
    reliability: 'വിശ്വാസ്യത',
    stability: 'സ്ഥിരത',
    safety: 'സുരക്ഷ',
    protection: 'സംരക്ഷണം',
    encryption: 'എൻക്രിപ്ഷൻ',
    authentication: 'ആധികാരികത',
    authorization: 'അംഗീകാരം',
    permission: 'അനുമതി',
    access: 'ആക്സസ്',
    rights: 'അവകാശങ്ങൾ',
    privileges: 'പ്രത്യേകാവകാശങ്ങൾ',
    roles: 'റോളുകൾ',
    users: 'ഉപയോക്താക്കൾ',
    groups: 'ഗ്രൂപ്പുകൾ',
    teams: 'ടീമുകൾ',
    organizations: 'സംഘടനകൾ',
    companies: 'കമ്പനികൾ',
    departments: 'വകുപ്പുകൾ',
    divisions: 'ഡിവിഷനുകൾ',
    branches: 'ശാഖകൾ',
    locations: 'സ്ഥലങ്ങൾ',
    regions: 'പ്രദേശങ്ങൾ',
    countries: 'രാജ്യങ്ങൾ',
    languages: 'ഭാഷകൾ',
    currencies: 'കറൻസികൾ',
    timezones: 'ടൈം സോണുകൾ',
    formats: 'ഫോർമാറ്റുകൾ',
    templates: 'ടെംപ്ലേറ്റുകൾ',
    themes: 'തീമുകൾ',
    styles: 'സ്റ്റൈലുകൾ',
    layouts: 'ലേഔട്ടുകൾ',
    designs: 'ഡിസൈനുകൾ',
    colors: 'നിറങ്ങൾ',
    fonts: 'ഫോണ്ടുകൾ',
    sizes: 'വലുപ്പങ്ങൾ',
    dimensions: 'അളവുകൾ',
    positions: 'സ്ഥാനങ്ങൾ',
    alignments: 'അലൈൻമെന്റുകൾ',
    margins: 'മാർജിനുകൾ',
    padding: 'പാഡിംഗ്',
    borders: 'ബോർഡറുകൾ',
    shadows: 'നിഴലുകൾ',
    effects: 'ഇഫക്റ്റുകൾ',
    animations: 'ആനിമേഷനുകൾ',
    transitions: 'ട്രാൻസിഷനുകൾ',
    interactions: 'ഇന്ററാക്ഷനുകൾ',
    gestures: 'ജെസ്ചറുകൾ',
    shortcuts: 'ഷോർട്ട്കട്ടുകൾ',
    hotkeys: 'ഹോട്ട്കീകൾ',
    commands: 'കമാൻഡുകൾ',
    functions: 'ഫംഗ്ഷനുകൾ',
    features: 'ഫീച്ചറുകൾ',
    capabilities: 'കഴിവുകൾ',
    tools: 'ടൂളുകൾ',
    utilities: 'യൂട്ടിലിറ്റികൾ',
    widgets: 'വിജറ്റുകൾ',
    components: 'കമ്പോണന്റുകൾ',
    modules: 'മൊഡ്യൂളുകൾ',
    plugins: 'പ്ലഗിനുകൾ',
    extensions: 'എക്സ്റ്റൻഷനുകൾ',
    addons: 'ആഡ്ഓണുകൾ',
    integrations: 'ഇന്റഗ്രേഷനുകൾ',
    connections: 'കണക്ഷനുകൾ',
    apis: 'എപിഐകൾ',
    services: 'സേവനങ്ങൾ',
    applications: 'ആപ്ലിക്കേഷനുകൾ',
    software: 'സോഫ്റ്റ്വെയർ',
    hardware: 'ഹാർഡ്വെയർ',
    devices: 'ഉപകരണങ്ങൾ',
    platforms: 'പ്ലാറ്റ്ഫോമുകൾ',
    systems: 'സിസ്റ്റങ്ങൾ',
    frameworks: 'ഫ്രെയിംവർക്കുകൾ',
    libraries: 'ലൈബ്രറികൾ',
    packages: 'പാക്കേജുകൾ',
    dependencies: 'ഡിപെൻഡൻസികൾ',
    requirements: 'ആവശ്യകതകൾ',
    specifications: 'സ്പെസിഫിക്കേഷനുകൾ',
    standards: 'മാനദണ്ഡങ്ങൾ',
    protocols: 'പ്രോട്ടോക്കോളുകൾ',
    schemas: 'സ്കീമകൾ',
    structures: 'ഘടനകൾ',
    models: 'മോഡലുകൾ',
    entities: 'എന്റിറ്റികൾ',
    objects: 'ഒബ്ജക്റ്റുകൾ',
    items: 'ഇനങ്ങൾ',
    elements: 'എലമെന്റുകൾ',
    parts: 'ഭാഗങ്ങൾ',
    pieces: 'കഷണങ്ങൾ',
    fragments: 'ശകലങ്ങൾ',
    sections: 'വിഭാഗങ്ങൾ',
    chapters: 'അധ്യായങ്ങൾ',
    pages: 'പേജുകൾ',
    articles: 'ലേഖനങ്ങൾ',
    posts: 'പോസ്റ്റുകൾ',
    entries: 'എൻട്രികൾ',
    records: 'രേഖകൾ',
    logs: 'ലോഗുകൾ',
    history: 'ചരിത്രം',
    timeline: 'ടൈംലൈൻ',
    schedule: 'ഷെഡ്യൂൾ',
    calendar: 'കലണ്ടർ',
    events: 'ഇവന്റുകൾ',
    appointments: 'അപ്പോയിന്റ്മെന്റുകൾ',
    meetings: 'മീറ്റിംഗുകൾ',
    conferences: 'കോൺഫറൻസുകൾ',
    calls: 'കോളുകൾ',
    messages: 'സന്ദേശങ്ങൾ',
    emails: 'ഇമെയിലുകൾ',
    reminders: 'ഓർമ്മപ്പെടുത്തലുകൾ',
    tasks: 'ടാസ്കുകൾ',
    todos: 'ചെയ്യേണ്ടവ',
    projects: 'പ്രോജക്റ്റുകൾ',
    workflows: 'വർക്ക്ഫ്ലോകൾ',
    processes: 'പ്രക്രിയകൾ',
    procedures: 'നടപടിക്രമങ്ങൾ',
    steps: 'ഘട്ടങ്ങൾ',
    stages: 'ഘട്ടങ്ങൾ',
    phases: 'ഘട്ടങ്ങൾ',
    milestones: 'നാഴികക്കല്ലുകൾ',
    deadlines: 'സമയപരിധികൾ',
    goals: 'ലക്ഷ്യങ്ങൾ',
    objectives: 'ഉദ്ദേശ്യങ്ങൾ',
    targets: 'ലക്ഷ്യങ്ങൾ',
    achievements: 'നേട്ടങ്ങൾ',
    results: 'ഫലങ്ങൾ',
    outcomes: 'ഫലങ്ങൾ',
    outputs: 'ഔട്ട്പുട്ടുകൾ',
    inputs: 'ഇൻപുട്ടുകൾ',
    resources: 'വിഭവങ്ങൾ',
    assets: 'ആസ്തികൾ',
    materials: 'മെറ്റീരിയലുകൾ',
    supplies: 'സപ്ലൈകൾ',
    equipment: 'ഉപകരണങ്ങൾ',
    instruments: 'ഉപകരണങ്ങൾ',
    machines: 'യന്ത്രങ്ങൾ',
    vehicles: 'വാഹനങ്ങൾ',
    facilities: 'സൗകര്യങ്ങൾ',
    buildings: 'കെട്ടിടങ്ങൾ',
    rooms: 'മുറികൾ',
    spaces: 'സ്ഥലങ്ങൾ',
    areas: 'പ്രദേശങ്ങൾ',
    zones: 'സോണുകൾ',
    done: 'പൂർത്തിയായി',
    undone: 'പൂർത്തിയാകാത്ത',
    accomplished: 'നേടിയ',
    unaccomplished: 'നേടാത്ത'
  },

  // Navigation
  navigation: {
    home: 'ഹോം',
    dashboard: 'ഡാഷ്ബോർഡ്',
    inventory: 'ഇൻവെന്ററി',
    orders: 'ഓർഡറുകൾ',
    customers: 'ഉപഭോക്താക്കൾ',
    suppliers: 'വിതരണക്കാർ',
    purchases: 'വാങ്ങലുകൾ',
    analytics: 'അനലിറ്റിക്സ്',
    reports: 'റിപ്പോർട്ടുകൾ',
    settings: 'സെറ്റിംഗുകൾ',
    profile: 'പ്രൊഫൈൽ',
    logout: 'ലോഗ് ഔട്ട്',
    help: 'സഹായം',
    support: 'പിന്തുണ'
  },

  // Authentication
  auth: {
    login: 'ലോഗിൻ',
    register: 'രജിസ്റ്റർ',
    logout: 'ലോഗ് ഔട്ട്',
    forgotPassword: 'പാസ്വേഡ് മറന്നോ',
    resetPassword: 'പാസ്വേഡ് റീസെറ്റ്',
    changePassword: 'പാസ്വേഡ് മാറ്റുക',
    email: 'ഇമെയിൽ',
    password: 'പാസ്വേഡ്',
    confirmPassword: 'പാസ്വേഡ് സ്ഥിരീകരിക്കുക',
    rememberMe: 'എന്നെ ഓർക്കുക',
    loginButton: 'സൈൻ ഇൻ',
    registerButton: 'സൈൻ അപ്പ്',
    alreadyHaveAccount: 'ഇതിനകം അക്കൗണ്ട് ഉണ്ടോ?',
    dontHaveAccount: 'അക്കൗണ്ട് ഇല്ലേ?',
    signInHere: 'ഇവിടെ സൈൻ ഇൻ ചെയ്യുക',
    signUpHere: 'ഇവിടെ സൈൻ അപ്പ് ചെയ്യുക',
    invalidCredentials: 'തെറ്റായ ഇമെയിൽ അല്ലെങ്കിൽ പാസ്വേഡ്',
    accountCreated: 'അക്കൗണ്ട് വിജയകരമായി സൃഷ്ടിച്ചു',
    passwordResetSent: 'പാസ്വേഡ് റീസെറ്റ് ലിങ്ക് നിങ്ങളുടെ ഇമെയിലിലേക്ക് അയച്ചു',
    passwordChanged: 'പാസ്വേഡ് വിജയകരമായി മാറ്റി',
    login_page: {
      title: 'The enterprise operating system.',
      features: {
        speed: { title: 'Local Speed', desc: 'High-performance architecture built for the Indian marketplace.' },
        trust: { title: 'Encrypted Trust', desc: 'Bank-grade security protocols for your sensitive financial data.' }
      },
      serving: 'Serving 10,000+ Indian Enterprises',
      welcome: 'Welcome back.',
      subtitle: 'Authorized access only. Please verify your credentials.',
      email_label: 'Email Architecture',
      password_label: 'Security Key',
      reset_access: 'Reset Access',
      submit: 'Initialize Dashboard',
      verifying: 'Verifying Credentials...',
      third_party: 'Third Party Auth',
      verify_google: 'Verify with Google',
      no_account: 'No account?',
      open_account: 'Open Enterprise Account'
    },
    register_page: {
      title: 'Join the elite tier.',
      features: {
        gst: { title: 'GST Optimized', desc: 'Enterprise-grade compliance engine.' },
        sync: { title: 'Atomic Sync', desc: 'Instant data propagation across devices.' }
      },
      testimonial: '"Soma is the infrastructure we needed to scale from 2 to 20 locations."',
      testimonial_author: 'Rajesh Kumar',
      testimonial_role: 'Owner, Global Traders',
      form_title: 'Open Account.',
      form_subtitle: 'Secure your business architecture with an elite 14-day trial.',
      labels: {
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Corporate Email',
        password: 'Security Key',
        confirm_password: 'Confirm Key',
        business_name: 'Business Identity',
        phone: 'Phone Number',
        entity_type: 'Entity Type',
        sector: 'Sector'
      },
      placeholders: {
        select_type: 'Select Type',
        select_industry: 'Select Industry'
      },
      submit: 'Request Access',
      already_registered: 'Already registered?',
      sign_in: 'Authorized Sign In'
    }
  },

  // Business Management
  // business: {
  //   name: 'ബിസിനസ് പേര്',
  //   type: 'ബിസിനസ് തരം',
  //   category: 'വിഭാഗം',
  //   description: 'വിവരണം',
  //   address: 'വിലാസം',
  //   phone: 'ഫോൺ നമ്പർ',
  //   email: 'ഇമെയിൽ വിലാസം',
  //   website: 'വെബ്സൈറ്റ്',
  //   gstNumber: 'ജിഎസ്ടി നമ്പർ',
  //   panNumber: 'പാൻ നമ്പർ',
  //   bankAccount: 'ബാങ്ക് അക്കൗണ്ട്',
  //   ifscCode: 'ഐഎഫ്എസ്സി കോഡ്',
  //   accountNumber: 'അക്കൗണ്ട് നമ്പർ',
  //   accountHolder: 'അക്കൗണ്ട് ഹോൾഡറുടെ പേര്'
  // },

  business: {
  profile: "ബിസിനസ് പ്രൊഫൈൽ",
  edit_profile: "പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യുക",
  create_profile: "ബിസിനസ് പ്രൊഫൈൽ സൃഷ്ടിക്കുക",
  edit_business_profile: "ബിസിനസ് പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യുക",
  create_business_profile: "ബിസിനസ് പ്രൊഫൈൽ സൃഷ്ടിക്കുക",
  no_profile_found: "ബിസിനസ് പ്രൊഫൈൽ കണ്ടെത്തിയില്ല",
  no_business_profile: "ബിസിനസ് പ്രൊഫൈൽ കണ്ടെത്തിയില്ല",
  no_business_profile_description: "നിങ്ങൾ ഇതുവരെ നിങ്ങളുടെ ബിസിനസ് പ്രൊഫൈൽ സജ്ജമാക്കിയിട്ടില്ല. എല്ലാ സവിശേഷതകളും ഉപയോഗിക്കാൻ ഒരു പ്രൊഫൈൽ സൃഷ്ടിക്കുക.",
  go_back: "പിന്നോട്ട് പോകുക",
  basic_info: "അടിസ്ഥാന വിവരങ്ങൾ",
  business_name: "ബിസിനസ് പേര്",
  enter_name: "ബിസിനസ് പേര് നൽകുക",
  business_type: "ബിസിനസ് തരം",
  select_type: "ബിസിനസ് തരം തിരഞ്ഞെടുക്കുക",
  email: "ഇമെയിൽ",
  enter_email: "ഇമെയിൽ വിലാസം നൽകുക",
  phone: "ഫോൺ",
  enter_phone: "ഫോൺ നമ്പർ നൽകുക",
  address: "വിലാസം",
  enter_address: "പൂർണ്ണ വിലാസം നൽകുക",
  category: "വിഭാഗം",
  select_category: "വിഭാഗം തിരഞ്ഞെടുക്കുക",
  annual_turnover: "വാർഷിക ടേൺഓവർ",
  select_turnover: "ടേൺഓവർ ശ്രേണി തിരഞ്ഞെടുക്കുക",
  turnover_range_0_5L: "₹0 - ₹5 ലക്ഷം",
  turnover_range_5L_20L: "₹5 ലക്ഷം - ₹20 ലക്ഷം",
  turnover_range_20L_1Cr: "₹20 ലക്ഷം - ₹1 കോടി",
  turnover_range_1Cr_plus: "₹1 കോടിയിലധികം",
  fetch_profile_error: "ബിസിനസ് പ്രൊഫൈൽ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു",
  fetch_gst_error: "GST ക്രമീകരണങ്ങൾ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു",
  toggle_gst_error: "GST സവിശേഷതകൾ ഓൺ/ഓഫ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
  update_gst_status_error: "GST നില അപ്‌ഡേറ്റ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
  save_error: "മാറ്റങ്ങൾ സേവ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
  gst_registered: "GST രജിസ്റ്റർ ചെയ്തിരിക്കുന്നു",
  gst_number: "GST നമ്പർ",
  registration_date: "രജിസ്ട്രേഷൻ തീയതി",
  flower_vendor: "പൂക്കച്ചവടക്കാരൻ",
  grocery_store: "ചരക്ക് കട",
  textile_shop: "ടെക്സ്റ്റൈൽ കട",
  hardware_store: "ഹാർഡ്‌വെയർ കട",
  electronics_shop: "ഇലക്ട്രോണിക്‌സ് കട",
  other: "മറ്റുള്ളവ",
  retailer: "ചില്ലറ വ്യാപാരി",
  wholesaler: "തോക്കുകച്ചവടക്കാരൻ",
  manufacturer: "നിർമാതാവ്",
  service_provider: "സേവനദാതാവ്",
  gst_configuration: "GST ക്രമീകരണം",
  enabled: "സജീവം",
  disabled: "നിഷ്‌ക്രിയം",
  gstin_number: "GSTIN നമ്പർ",
  gstin_placeholder: "22AAAAA0000A1Z5",
  default_cgst: "ഡീഫോൾട്ട് CGST (%)",
  default_sgst: "ഡീഫോൾട്ട് SGST (%)",
  default_igst: "ഡീഫോൾട്ട് IGST (%)",
  auto_sync: "GST പോർട്ടലുമായി ഇൻവോയിസുകൾ സ്വയം സിങ്ക് ചെയ്യുക",
  business_settings: "ബിസിനസ് ക്രമീകരണങ്ങൾ",
  manage_business_preferences: "നിങ്ങളുടെ ബിസിനസ് മുൻഗണനകളും ക്രമീകരണങ്ങളും നിയന്ത്രിക്കുക",
  general_settings: "പൊതു ക്രമീകരണങ്ങൾ",
  configure_general_settings: "അടിസ്ഥാന ബിസിനസ് ക്രമീകരണങ്ങൾ ക്രമീകരിക്കുക",
  language: "ഭാഷ",
  select_language: "ഭാഷ തിരഞ്ഞെടുക്കുക",
  currency: "കറൻസി",
  select_currency: "കറൻസി തിരഞ്ഞെടുക്കുക",
  timezone: "സമയ മേഖല",
  select_timezone: "സമയ മേഖല തിരഞ്ഞെടുക്കുക",
  notifications: "അറിയിപ്പുകൾ",
  manage_notification_preferences: "നിങ്ങളുടെ അറിയിപ്പ് മുൻഗണനകൾ നിയന്ത്രിക്കുക",
  low_stock_alerts: "കുറഞ്ഞ സ്റ്റോക്ക് അലർട്ടുകൾ",
  low_stock_description: "സ്റ്റോക്ക് കുറയുമ്പോൾ അറിയിപ്പ് ലഭിക്കുക",
  expiring_items: "കാലഹരണപ്പെടുന്ന ഇനങ്ങൾ",
  expiring_items_description: "കാലാവധി അടുത്തിരിക്കുന്ന ഇനങ്ങളെക്കുറിച്ച് അറിയിപ്പ് ലഭിക്കുക",
  order_updates: "ഓർഡർ അപ്‌ഡേറ്റുകൾ",
  order_updates_description: "പുതിയ ഓർഡറുകളും നില മാറ്റങ്ങളും സംബന്ധിച്ച അറിയിപ്പുകൾ ലഭിക്കുക",
  save_changes: "മാറ്റങ്ങൾ സേവ് ചെയ്യുക",
  saving: "സേവ് ചെയ്യുന്നു...",
  cancel: "റദ്ദാക്കുക",
  create_profile_btn: "പ്രൊഫൈൽ സൃഷ്ടിക്കുക",
  yes: "അതെ",
  no: "ഇല്ല",
  n_a: "ബാധകമല്ല",
  settings_saved_successfully: "ക്രമീകരണങ്ങൾ വിജയകരമായി സേവ് ചെയ്തു",
  failed_to_save_settings: "ക്രമീകരണങ്ങൾ സേവ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
  failed_to_load_settings: "ക്രമീകരണങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
  profile_updated: "പ്രൊഫൈൽ വിജയകരമായി അപ്‌ഡേറ്റ് ചെയ്തു",
  business_profile_created: "ബിസിനസ് പ്രൊഫൈൽ വിജയകരമായി സൃഷ്ടിച്ചു!",
  error_saving: "സേവ് ചെയ്യുമ്പോൾ ഒരു പിശക് സംഭവിച്ചു",
  error_creating: "പ്രൊഫൈൽ സൃഷ്ടിക്കുമ്പോൾ ഒരു പിശക് സംഭവിച്ചു",
  could_not_fetch_business_profile: "ബിസിനസ് പ്രൊഫൈൽ ലഭ്യമാക്കാൻ കഴിഞ്ഞില്ല",
  business_profile_not_found: "ബിസിനസ് പ്രൊഫൈൽ കണ്ടെത്തിയില്ല",
  not_provided: "നൽകിയിട്ടില്ല",
  business_label: "ബിസിനസ്"
},

  business_settings_page: {
    business_settings: "ബിസിനസ് ക്രമീകരണങ്ങൾ",
    manage_business_preferences: "നിങ്ങളുടെ ബിസിനസ്സ് മുൻഗണനകളും കോൺഫിഗറേഷനുകളും നിയന്ത്രിക്കുക",
    general_settings: "പൊതു ക്രമീകരണങ്ങൾ",
    configure_general_settings: "അടിസ്ഥാന ബിസിനസ്സ് ക്രമീകരണങ്ങൾ കോൺഫിഗർ ചെയ്യുക",
    language: "ഭാഷ",
    currency: "കറൻസി",
    select_currency: "കറൻസി തിരഞ്ഞെടുക്കുക",
    timezone: "സമയ മേഖല",
    select_timezone: "സമയ മേഖല തിരഞ്ഞെടുക്കുക",
    notifications: "അറിയിപ്പുകൾ",
    manage_notification_preferences: "നിങ്ങളുടെ അറിയിപ്പ് മുൻഗണനകൾ നിയന്ത്രിക്കുക",
    low_stock_alerts: "കുറഞ്ഞ സ്റ്റോക്ക് അലേർട്ടുകൾ",
    low_stock_description: "ഇൻവെന്ററി കുറവാകുമ്പോൾ അറിയിപ്പ് ലഭിക്കും",
    expiring_items: "കാലഹരണപ്പെടുന്ന ഇനങ്ങൾ",
    expiring_items_description: "കാലഹരണപ്പെടുന്ന ഇനങ്ങളെക്കുറിച്ച് അറിയിപ്പ് ലഭിക്കും",
    order_updates: "ഓർഡർ അപ്‌ഡേറ്റുകൾ",
    order_updates_description: "പുതിയ ഓർഡറുകളെക്കുറിച്ചും സ്റ്റാറ്റസ് മാറ്റങ്ങളെക്കുറിച്ചും അറിയിപ്പ് ലഭിക്കും",
    saving: "സേവ് ചെയ്യുന്നു...",
    save_changes: "മാറ്റങ്ങൾ സേവ് ചെയ്യുക",
    failed_to_load_settings: "ക്രമീകരണങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    settings_saved_successfully: "ക്രമീകരണങ്ങൾ വിജയകരമായി സേവ് ചെയ്തു",
    failed_to_save_settings: "ക്രമീകരണങ്ങൾ സേവ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു"
  },

  // Inventory Management
  inventory: {
    items: 'ഇനങ്ങൾ',
    item: 'ഇനം',
    product: 'ഉൽപ്പന്നം',
    service: 'സേവനം',
    sku: 'എസ്കെയു',
    barcode: 'ബാർകോഡ്',
    category: 'വിഭാഗം',
    brand: 'ബ്രാൻഡ്',
    unit: 'യൂണിറ്റ്',
    quantity: 'അളവ്',
    price: 'വില',
    cost: 'ചെലവ്',
    sellingPrice: 'വിൽപ്പന വില',
    purchasePrice: 'വാങ്ങൽ വില',
    stock: 'സ്റ്റോക്ക്',
    lowStock: 'കുറഞ്ഞ സ്റ്റോക്ക്',
    outOfStock: 'സ്റ്റോക്ക് ഇല്ല',
    inStock: 'സ്റ്റോക്കിൽ ഉണ്ട്',
    stockAlert: 'സ്റ്റോക്ക് അലേർട്ട്',
    reorderLevel: 'റീഓർഡർ ലെവൽ',
    maxStock: 'പരമാവധി സ്റ്റോക്ക്',
    minStock: 'കുറഞ്ഞ സ്റ്റോക്ക്',
    addItem: 'ഇനം ചേർക്കുക',
    editItem: 'ഇനം എഡിറ്റ് ചെയ്യുക',
    deleteItem: 'ഇനം ഇല്ലാതാക്കുക',
    bulkImport: 'ബൾക്ക് ഇമ്പോർട്ട്',
    bulkExport: 'ബൾക്ക് എക്സ്പോർട്ട്',
    stockUpdate: 'സ്റ്റോക്ക് അപ്ഡേറ്റ്',
    stockAdjustment: 'സ്റ്റോക്ക് അഡ്ജസ്റ്റ്മെന്റ്',
    stockTransfer: 'സ്റ്റോക്ക് ട്രാൻസ്ഫർ'
  },

  // Time formatting
  time: {
    justNow: 'ഇപ്പോൾ തന്നെ',
    minutesAgo: '{{count}} മിനിറ്റ് മുമ്പ്',
    hoursAgo: '{{count}} മണിക്കൂർ മുമ്പ്',
    daysAgo: '{{count}} ദിവസം മുമ്പ്',
    weeksAgo: '{{count}} ആഴ്ച മുമ്പ്',
    monthsAgo: '{{count}} മാസം മുമ്പ്',
    yearsAgo: '{{count}} വർഷം മുമ്പ്'
  },

  // Pluralization
  items: {
    one: '{{count}} ഇനം',
    other: '{{count}} ഇനങ്ങൾ'
  },

  customers: {
    one: '{{count}} ഉപഭോക്താവ്',
    other: '{{count}} ഉപഭോക്താക്കൾ'
  },

  orders: {
    one: '{{count}} ഓർഡർ',
    other: '{{count}} ഓർഡറുകൾ'
  },

  // dashboard: {
  //   "dashboard": "ഡാഷ്ബോർഡ്",
    "business_overview": "ബിസിനസ് അവലോകനം",
    "action_required": "നടപടി ആവശ്യമാണ്",
    "profile_incomplete_message": "നിങ്ങളുടെ ബിസിനസ് പ്രൊഫൈൽ അപൂർണ്ണമാണ്. തുടരുന്നതിന് ആവശ്യമായ വിശദാംശങ്ങൾ നൽകുക.",
    "complete_profile": "പ്രൊഫൈൽ പൂർത്തിയാക്കുക",
    "quick_actions": "ദ്രുത പ്രവർത്തനങ്ങൾ",
    "add_sale": "വിൽപ്പന ചേർക്കുക",
    "manage_stock": "സ്റ്റോക്ക് നിയന്ത്രിക്കുക",
    "view_orders": "ഓർഡറുകൾ കാണുക",
    "todays_overview": "ഇന്നത്തെ അവലോകനം",
    "weeks_overview": "ഈ ആഴ്ചയിലെ അവലോകനം",
    "months_overview": "ഈ മാസത്തെ അവലോകനം",
    "business_management": "ബിസിനസ് മാനേജ്മെന്റ്",
    "inventory_management": "ഇൻവെന്ററി മാനേജ്മെന്റ്",
    "inventory_management_subtitle": "ഉൽപ്പന്നങ്ങളും സ്റ്റോക്കും നിയന്ത്രിക്കുക",
    "order_management": "ഓർഡർ മാനേജ്മെന്റ്",
    "order_management_subtitle": "ഓർഡറുകൾ ട്രാക്ക് ചെയ്യുകയും പൂർത്തിയാക്കുകയും ചെയ്യുക",
    "purchase_management": "വാങ്ങൽ മാനേജ്മെന്റ്",
    "purchase_management_subtitle": "വാങ്ങലുകൾ ട്രാക്ക് ചെയ്യുകയും നിയന്ത്രിക്കുകയും ചെയ്യുക",
    "customer_management": "ഉപഭോക്തൃ മാനേജ്മെന്റ്",
    "customer_management_subtitle": "ഉപഭോക്തൃ ബന്ധങ്ങൾ നിയന്ത്രിക്കുക",
    "supplier_management": "വിതരണക്കാരുടെ മാനേജ്മെന്റ്",
    "supplier_management_subtitle": "വിതരണക്കാരുമായുള്ള ബന്ധങ്ങൾ നിയന്ത്രിക്കുക",
    "business_analytics": "ബിസിനസ് അനലിറ്റിക്സ്",
    "business_analytics_subtitle": "പ്രകടന മെട്രിക്കുകൾ കാണുക"
  },
  settings: {
    "settingsTitle": "ക്രമീകരണങ്ങൾ",
    "inventorySection": "ഇൻവെന്ററി",
    "lowStockThresholdLabel": "കുറഞ്ഞ സ്റ്റോക്ക് പരിധി",
    "lowStockThresholdDescription": "ഒരു അലേർട്ട് ട്രിഗർ ചെയ്യുന്നതിന് മുമ്പുള്ള ഏറ്റവും കുറഞ്ഞ സ്റ്റോക്ക് ലെവൽ.",
    "stockAlertsLabel": "സ്റ്റോക്ക് അലേർട്ടുകൾ",
    "stockAlertsDescription": "കുറഞ്ഞ സ്റ്റോക്കിനായി അറിയിപ്പുകൾ സ്വീകരിക്കുക.",
    "autoReorderLabel": "ഓട്ടോ റീ-ഓർഡർ",
    "autoReorderDescription": "സ്റ്റോക്ക് കുറവായിരിക്കുമ്പോൾ യാന്ത്രികമായി വാങ്ങൽ ഓർഡറുകൾ സൃഷ്ടിക്കുക.",
    "ordersSection": "ഓർഡറുകൾ",
    "autoConfirmOrdersLabel": "ഓർഡറുകൾ യാന്ത്രികമായി സ്ഥിരീകരിക്കുക",
    "autoConfirmOrdersDescription": "വരുന്ന ഓർഡറുകൾ യാന്ത്രികമായി അംഗീകരിക്കുകയും പ്രോസസ്സ് ചെയ്യുകയും ചെയ്യുക.",
    "defaultPaymentMethodLabel": "ഡിഫോൾട്ട് പേയ്‌മെന്റ് രീതി",
    "defaultPaymentMethodDescription": "പുതിയ ഓർഡറുകൾക്കായി ഒരു ഡിഫോൾട്ട് പേയ്‌മെന്റ് രീതി സജ്ജമാക്കുക.",
    "orderNumberPrefixLabel": "ഓർഡർ നമ്പർ പ്രിഫിക്‌സ്",
    "orderNumberPrefixDescription": "എല്ലാ ഓർഡർ നമ്പറുകൾക്കുമായി ഒരു ഇഷ്ടാനുസൃത പ്രിഫിക്‌സ് (ഉദാ., 'ORD-').",
    "invoicingSection": "ഇൻവോയ്സിംഗ്",
    "autoGenerateInvoicesLabel": "ഇൻവോയ്സുകൾ യാന്ത്രികമായി സൃഷ്ടിക്കുക",
    "autoGenerateInvoicesDescription": "ഓരോ ഓർഡറിനും യാന്ത്രികമായി ഒരു പുതിയ ഇൻവോയ്സ് സൃഷ്ടിക്കുക.",
    "invoiceNumberPrefixLabel": "ഇൻവോയ്സ് നമ്പർ പ്രിഫിക്‌സ്",
    "invoiceNumberPrefixDescription": "എല്ലാ ഇൻവോയ്സ് നമ്പറുകൾക്കുമായി ഒരു ഇഷ്ടാനുസൃത പ്രിഫിക്‌സ് (ഉദാ., 'INV-').",
    "defaultTaxRateLabel": "ഡിഫോൾട്ട് നികുതി നിരക്ക് (%)",
    "defaultTaxRateDescription": "പുതിയ ഇൻവോയ്സുകളിൽ പ്രയോഗിക്കുന്ന ഡിഫോൾട്ട് നികുതി നിരക്ക്.",
    "paymentTermsLabel": "പേയ്മെന്റ് നിബന്ധനകൾ",
    "paymentTermsDescription": "ഇൻവോയ്സുകൾക്കുള്ള ഡിഫോൾട്ട് പേയ്മെന്റ് നിബന്ധനകൾ (ഉദാ., 'നെറ്റ് 30').",
    "reportingSection": "റിപ്പോർട്ടിംഗ്",
    "autoEmailReportsLabel": "റിപ്പോർട്ടുകൾ യാന്ത്രികമായി ഇമെയിൽ ചെയ്യുക",
    "autoEmailReportsDescription": "നിങ്ങളുടെ ഇമെയിൽ വിലാസത്തിലേക്ക് ഷെഡ്യൂൾ ചെയ്ത റിപ്പോർട്ടുകൾ അയയ്ക്കുക.",
    "defaultReportPeriodLabel": "ഡിഫോൾട്ട് റിപ്പോർട്ട് കാലയളവ്",
    "defaultReportPeriodDescription": "എല്ലാ റിപ്പോർട്ടുകൾക്കുമായി ഒരു ഡിഫോൾട്ട് കാലയളവ് സജ്ജമാക്കുക (ഉദാ., 'പ്രതിമാസം', 'പ്രതിവാരം').",
    "reportFormatLabel": "റിപ്പോർട്ട് ഫോർമാറ്റ്",
    "reportFormatDescription": "റിപ്പോർട്ടുകൾക്കായി ഡിഫോൾട്ട് ഫയൽ ഫോർമാറ്റ് തിരഞ്ഞെടുക്കുക (ഉദാ., 'പിഡിഎഫ്', 'സിഎസ്വി').",
    "loadSettingsError": "ക്രമീകരണങ്ങൾ ലോഡുചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു: {{message}}",
    "updateFailedError": "അപ്ഡേറ്റ് പരാജയപ്പെട്ടു",
    "invalidInputError": "അസാധുവായ ഇൻപുട്ട്",
    "enterValidNumberError": "ദയവായി ഒരു സാധുവായ നമ്പർ നൽകുക.",
    "selectOption": "തിരഞ്ഞെടുക്കുക",
    "paymentMethodCash": "പണം",
    "paymentMethodCard": "കാർഡ്",
    "paymentMethodUPI": "യുപിഐ",
    "paymentMethodBankTransfer": "ബാങ്ക് ട്രാൻസ്ഫർ",
    "reportPeriodDaily": "ദിവസേന",
    "reportPeriodWeekly": "പ്രതിവാരം",
    "reportPeriodMonthly": "പ്രതിമാസം",
    "reportPeriodQuarterly": "ത്രൈമാസികം",
    "reportFormatPDF": "പിഡിഎഫ്",
    "reportFormatExcel": "എക്സൽ",
    "reportFormatCSV": "സിഎസ്വി",
    "enterValuePlaceholder": "മൂല്യം നൽകുക"
  },
  businessProfile: {
    "no_business_profile": "ബിസിനസ് പ്രൊഫൈൽ ഇല്ല",
    "no_business_profile_description": "നിങ്ങൾ ഇതുവരെ നിങ്ങളുടെ ബിസിനസ് പ്രൊഫൈൽ സജ്ജീകരിച്ചിട്ടില്ലെന്ന് തോന്നുന്നു.",
    "create_business_profile": "ബിസിനസ് പ്രൊഫൈൽ സൃഷ്ടിക്കുക",
    "failed_to_fetch_business_profile": "ബിസിനസ് പ്രൊഫൈൽ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു",
    "could_not_fetch_business_profile": "ബിസിനസ് പ്രൊഫൈൽ ലഭ്യമാക്കാൻ കഴിഞ്ഞില്ല. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    "flower_vendor": "പൂവ് വിൽപ്പനക്കാരൻ",
    "grocery_store": "പലചരക്ക് കട",
    "textile_shop": "തുണിക്കട",
    "hardware_store": "ഹാർഡ്‌വെയർ സ്റ്റോർ",
    "electronics_shop": "ഇലക്ട്രോണിക്സ് കട"
  },
  businessSettings: {
    "businessSettings": "ബിസിനസ് ക്രമീകരണങ്ങൾ",
    "currency": "കറൻസി",
    "setCurrency": "നിങ്ങളുടെ ബിസിനസ്സിനായി സ്ഥിരസ്ഥിതി കറൻസി സജ്ജമാക്കുക.",
    "language": "ഭാഷ",
    "setLanguage": "നിങ്ങളുടെ അക്കൗണ്ടിനായി ഭാഷ സജ്ജമാക്കുക.",
    "timezone": "സമയമേഖല",
    "setTimezone": "നിങ്ങളുടെ ബിസിനസ്സിനായി സമയമേഖല സജ്ജമാക്കുക.",
    "notifications": "അറിയിപ്പുകൾ",
    "lowStockAlerts": "കുറഞ്ഞ സ്റ്റോക്ക് അലേർട്ടുകൾ",
    "lowStockDescription": "കുറഞ്ഞ സ്റ്റോക്ക് ഇനങ്ങൾക്കായി അലേർട്ടുകൾ സ്വീകരിക്കുക.",
    "expiringItems": "കാലഹരണപ്പെടുന്ന ഇനങ്ങൾ",
    "expiringItemsDescription": "അവയുടെ കാലഹരണപ്പെടുന്ന തീയതിക്ക് അടുത്തുള്ള ഇനങ്ങൾക്കായി അലേർട്ടുകൾ സ്വീകരിക്കുക.",
    "orderUpdates": "ഓർഡർ അപ്‌ഡേറ്റുകൾ",
    "orderUpdatesDescription": "പുതിയ ഓർഡറുകൾക്കും ഓർഡർ നില മാറ്റങ്ങൾക്കുമായി അലേർട്ടുകൾ സ്വീകരിക്കുക.",
    "select": "തിരഞ്ഞെടുക്കുക",
    "updateFailed": "അപ്ഡേറ്റ് പരാജയപ്പെട്ടു",
    "loadingError": "ക്രമീകരണങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    "inr": "ഇന്ത്യൻ രൂപ (INR)",
    "usd": "യുഎസ് ഡോളർ (USD)",
    "en": "ഇംഗ്ലീഷ്",
    "hi": "ഹിന്ദി",
    "te": "തെലുങ്ക്",
    "ta": "തമിഴ്",
    "kn": "കന്നഡ",
    "ml": "മലയാളം",
    "kolkata": "ഏഷ്യ/കൊൽക്കത്ത"
  },
  profile: {
    "profile": "പ്രൊഫൈൽ",
    "manage_your_account_settings": "നിങ്ങളുടെ അക്കൗണ്ട് ക്രമീകരണങ്ങൾ നിയന്ത്രിക്കുക",
    "active": "സജീവം",
    "business": "ബിസിനസ്സ്",
    "business_profile": "ബിസിനസ്സ് പ്രൊഫൈൽ",
    "business_settings": "ബിസിനസ്സ് ക്രമീകരണങ്ങൾ",
    "subscription": "സബ്സ്ക്രിപ്ഷൻ",
    "reports_and_analytics": "റിപ്പോർട്ടുകളും വിശകലനങ്ങളും",
    "account": "അക്കൗണ്ട്",
    "edit_profile": "പ്രൊഫൈൽ എഡിറ്റുചെയ്യുക",
    "security_and_privacy": "സുരക്ഷയും സ്വകാര്യതയും",
    "settings": "ക്രമീകരണങ്ങൾ",
    "preferences": "മുൻഗണനകൾ",
    "advance_view": "അഡ്വാൻസ് വ്യൂ",
    "help_and_support": "സഹായവും പിന്തുണയും",
    "about_soma": "സോമയെക്കുറിച്ച്",
    "sign_out": "സൈൻ ഔട്ട് ചെയ്യുക",
    "logout": "ലോഗ് ഔട്ട്",
    "are_you_sure_you_want_to_logout": "നിങ്ങൾ തീർച്ചയായും ലോഗ് ഔട്ട് ചെയ്യാൻ ആഗ്രഹിക്കുന്നുണ്ടോ?"
  },
  dashboard: {
    dashboard: "ഡാഷ്‌ബോർഡ്",
    business_overview: "ബിസിനസ്സ് അവലോകനം",
    action_required: "നടപടി ആവശ്യമാണ്",
    profile_incomplete_message: "നിങ്ങളുടെ ബിസിനസ്സ് പ്രൊഫൈൽ അപൂർണ്ണമാണ്. തുടരാൻ ദയവായി ആവശ്യമായ വിവരങ്ങൾ നൽകുക.",
    complete_profile: "പ്രൊഫൈൽ പൂർത്തിയാക്കുക",
    quick_actions: "ദ്രുത നടപടികൾ",
    add_sale: "വിൽപ്പന ചേർക്കുക",
    manage_stock: "സ്റ്റോക്ക് നിയന്ത്രിക്കുക",
    view_orders: "ഓർഡറുകൾ കാണുക",
    todays_overview: "ഇന്നത്തെ അവലോകനം",
    weeks_overview: "ഈ ആഴ്‌ചയിലെ അവലോകനം",
    months_overview: "ഈ മാസത്തെ അവലോകനം",
    low_stock: "കുറഞ്ഞ സ്റ്റോക്ക്",
    business_management: "ബിസിനസ്സ് മാനേജ്മെന്റ്",
    inventory_management_subtitle: "ഉൽപ്പന്നങ്ങളും സ്റ്റോക്കും നിയന്ത്രിക്കുക",
    order_management_subtitle: "ഓർഡറുകൾ ട്രാക്കുചെയ്യുക, പൂർത്തിയാക്കുക",
    purchase_management_subtitle: "വാങ്ങലുകൾ ട്രാക്കുചെയ്യുക, നിയന്ത്രിക്കുക",
    customer_management_subtitle: "ഉപഭോക്തൃ ബന്ധങ്ങൾ നിയന്ത്രിക്കുക",
    supplier_management_subtitle: "വിതരണക്കാരുടെ ബന്ധങ്ങൾ നിയന്ത്രിക്കുക",
    business_analytics_subtitle: "പ്രകടന മെട്രിക്സ് കാണുക",
    welcome_back: "സ്വാഗതം",
    orders_need_attention: "ശ്രദ്ധ ആവശ്യമായ ഓർഡറുകൾ",
    total_revenue: "ആകെ വരുമാനം",
    active_orders: "സജീവമായ ഓർഡറുകൾ",
    stock_value: "സ്റ്റോക്ക് മൂല്യം",
    total_customers: "ആകെ ഉപഭോക്താക്കൾ",
    live: "ലൈവ്",
    monthly_sales: "പ്രതിമാസ വിൽപ്പന",
    view_details: "വിശദാംശങ്ങൾ കാണുക",
    recent_orders: "സമീപകാല ഓർഡറുകൾ",
    view_all: "എല്ലാം കാണുക",
    order_id: "ഓർഡർ ഐഡി",
    customer: "ഉപഭോക്താവ്",
    amount: "തുക",
    status: "അവസ്ഥ",
    important_tasks: "പ്രധാനപ്പെട്ട ജോലികൾ",
    in_stock: "സ്റ്റോക്കുണ്ട്",
    buy_more: "കൂടുതൽ വാങ്ങുക",
    manage_inventory: "ഇൻവെന്ററി മാനേജ്മെന്റ്",
    goals: "ലക്ഷ്യങ്ങൾ",
    sales_goal: "വിൽപ്പന ലക്ഷ്യം",
    revenue_goal: "വരുമാന ലക്ഷ്യം",
    search_placeholder: "ഓർഡറുകൾ, ഉപഭോക്താക്കൾ അല്ലെങ്കിൽ ഉൽപ്പന്നങ്ങൾ തിരയുക...",
    loading: "ലോഡുചെയ്യുന്നു..."
  },
  analytics: {
    title: "അനലിറ്റിക്സ്",
    subtitle: "ബിസിനസ്സ് പ്രകടന സ്ഥിതിവിവരക്കണക്കുകൾ",
    last_7_days: "കഴിഞ്ഞ 7 ദിവസങ്ങൾ",
    last_30_days: "കഴിഞ്ഞ 30 ദിവസങ്ങൾ",
    last_3_months: "കഴിഞ്ഞ 3 മാസങ്ങൾ",
    business_reports: "ബിസിനസ്സ് റിപ്പോർട്ടുകൾ",
    sales_forecast: "വിൽപ്പന പ്രവചനം",
    reports_library: "റിപ്പോർട്ട് ലൈബ്രറി",
    total_revenue: "ആകെ വരുമാനം",
    average_order_value: "ശരാശരി ഓർഡർ മൂല്യം",
    growth_rate: "വളർച്ചാ നിരക്ക്",
    total_orders: "ആകെ ഓർഡറുകൾ",
    sales_by_channel: "ചാനൽ വഴിയുള്ള വിൽപ്പന",
    sales_breakdown: "വിൽപ്പനയുടെ വിശദാംശങ്ങൾ",
    online_sales: "ഓൺലൈൻ വിൽപ്പന",
    store_sales: "സ്റ്റോർ വിൽപ്പന",
    wholesale_sales: "മൊത്ത വിൽപ്പന",
    ai_suggestions: "AI നിർദ്ദേശങ്ങൾ",
    ai_insight_1: "ഇൻവെന്ററി ഒപ്റ്റിമൈസേഷൻ",
    ai_insight_1_desc: "സ്റ്റോക്ക്ഔട്ടുകൾ തടയാൻ 'പ്രീമിയം സിൽക്ക് സാരി' റീഓർഡർ ചെയ്യുന്നത് പരിഗണിക്കുക.",
    next_month: "അടുത്ത മാസം",
    next_3_months: "അടുത്ത 3 മാസങ്ങൾ",
    accuracy: "കൃത്യത",
    sales_growth: "വിൽപ്പന വളർച്ച",
    sales_growth_subtitle: "കഴിഞ്ഞ മാസത്തെ അപേക്ഷിച്ച് കണക്കാക്കിയ വളർച്ച",
    search_reports: "റിപ്പോർട്ട് ടെംപ്ലേറ്റുകൾ തിരയുക...",
    reports_available: "റിപ്പോർട്ടുകൾ ലഭ്യമാണ്",
    no_reports: "റിപ്പോർട്ടുകളൊന്നും കണ്ടെത്തിയില്ല",
    no_reports_desc: "മറ്റ് തിരയൽ വാക്കുകൾ പരീക്ഷിക്കുക അല്ലെങ്കിൽ പുതിയ ഇഷ്‌ടാനുസൃത റിപ്പോർട്ട് സൃഷ്‌ടിക്കുക.",
    report_name: "റിപ്പോർട്ടിന്റെ പേര്",
    system_default: "സിസ്റ്റം ഡിഫോൾട്ട്",
    description: "വിവരണം",
    actions: "നടപടികൾ",
    edit: "എഡിറ്റുചെയ്യുക",
    generate: "സൃഷ്ടിക്കുക"
  },
  // business: {
  //   profile: "Business Profile",
  //   edit_profile: "Edit Profile",
  //   create_profile: "Create Business Profile",
  //   edit_business_profile: "Edit Business Profile",
  //   create_business_profile: "Create Business Profile",
  //   no_profile_found: "No Business Profile Found",
  //   no_business_profile: "No Business Profile Found",
  //   no_business_profile_description: "You haven't set up your business profile yet. Create one to unlock all features.",
  //   go_back: "Go Back",
  //   basic_info: "Basic Information",
  //   business_name: "Business Name",
  //   enter_name: "Enter business name",
  //   business_type: "Business Type",
  //   select_type: "Select business type",
  //   email: "Email",
  //   phone: "Phone",
  //   address: "Address",
  //   enter_address: "Enter complete address",
  //   category: "Category",
  //   select_category: "Select category",
  //   annual_turnover: "Annual Turnover",
  //   select_turnover: "Select turnover range",
  //   gst_registered: "GST Registered",
  //   gst_number: "GST Number",
  //   registration_date: "Registration Date",
  //   flower_vendor: "Flower Vendor",
  //   grocery_store: "Grocery Store",
  //   textile_shop: "Textile Shop",
  //   hardware_store: "Hardware Store",
  //   electronics_shop: "Electronics Shop",
  //   other: "Other",
  //   retailer: "Retailer",
  //   wholesaler: "Wholesaler",
  //   manufacturer: "Manufacturer",
  //   service_provider: "Service Provider",
  //   gst_configuration: "GST Configuration",
  //   enabled: "Enabled",
  //   disabled: "Disabled",
  //   gstin_number: "GSTIN Number",
  //   default_cgst: "Default CGST (%)",
  //   default_sgst: "Default SGST (%)",
  //   default_igst: "Default IGST (%)",
  //   auto_sync: "Auto-sync invoices with GST portal",
  //   business_settings: "Business Settings",
  //   manage_business_preferences: "Manage your business preferences and configurations",
  //   general_settings: "General Settings",
  //   configure_general_settings: "Configure basic business settings",
  //   language: "Language",
  //   select_language: "Select Language",
  //   currency: "Currency",
  //   select_currency: "Select Currency",
  //   timezone: "Timezone",
  //   select_timezone: "Select Timezone",
  //   notifications: "Notifications",
  //   manage_notification_preferences: "Manage your notification preferences",
  //   low_stock_alerts: "Low Stock Alerts",
  //   low_stock_description: "Get notified when inventory runs low",
  //   expiring_items: "Expiring Items",
  //   expiring_items_description: "Get notified about items nearing expiration",
  //   order_updates: "Order Updates",
  //   order_updates_description: "Get notified about new orders and status changes",
  //   save_changes: "Save Changes",
  //   saving: "Saving...",
  //   cancel: "Cancel",
  //   create_profile_btn: "Create Profile",
  //   yes: "Yes",
  //   no: "No",
  //   n_a: "N/A",
  //   settings_saved_successfully: "Settings saved successfully",
  //   failed_to_save_settings: "Failed to save settings",
  //   failed_to_load_settings: "Failed to load settings",
  //   profile_updated: "Profile updated successfully",
  //   business_profile_created: "Business profile created successfully!",
  //   error_saving: "An error occurred while saving",
  //   error_creating: "An error occurred while creating profile",
  //   could_not_fetch_business_profile: "Could not fetch business profile",
  //   business_profile_not_found: "Business profile not found",
  //   not_provided: "Not provided",
  //   business_label: "Business"
  // },
  orders_page: {
      title: 'ഓർഡറുകൾ',
      description: 'നിങ്ങളുടെ എല്ലാ ഓർഡറുകളും കൈകാര്യം ചെയ്യുക',
      create_new_order: 'പുതിയ ഓർഡർ സൃഷ്ടിക്കുക',
      total_orders: 'ആകെ ഓർഡറുകൾ',
      pending_orders: 'തീർപ്പുകൽപ്പിക്കാത്ത ഓർഡറുകൾ',
      completed_orders: 'പൂർത്തിയാക്കിയ ഓർഡറുകൾ',
      direct_sales: 'നേരിട്ടുള്ള വിൽപ്പന',
      search_placeholder: 'ഓർഡർ ഐഡി അല്ലെങ്കിൽ ഉപഭോക്തൃ പേര് ഉപയോഗിച്ച് തിരയുക...',
      filter_all: 'എല്ലാം',
      filter_pending: 'തീർപ്പുകൽപ്പിക്കാത്തത്',
      filter_completed: 'പൂർത്തിയായി',
      no_orders: 'ഓർഡറുകൾ ഒന്നുമില്ല',
      no_orders_desc: 'ഓർഡറുകൾ കണ്ടെത്തിയില്ല',
      delete_confirmation: 'ഈ ഓർഡർ നീക്കം ചെയ്യണോ?',
      col_order_id: 'ഓർഡർ ഐഡി',
      col_customer_name: 'ഉപഭോക്താവിന്റെ പേര്',
      guest: 'അതിഥി',
      col_order_status: 'ഓർഡർ നില',
      standard: 'സ്റ്റാൻഡേർഡ്',
      col_amount: 'തുക',
      total: 'ആകെ',
      col_actions: 'പ്രവർത്തനങ്ങൾ',
      wire: 'വയർ',
      error_loading_sample: 'ലോഡുചെയ്യുന്നു... മാതൃകാ ഡാറ്റ കാണിക്കുന്നു'
    },


  inventory_page: {
    inventory: "ഇൻവെന്ററി",
    manage_inventory: "നിങ്ങളുടെ ഉൽപ്പന്നങ്ങളും സ്റ്റോക്ക് ലെവലുകളും കൈകാര്യം ചെയ്യുക",
    add_product: "ഉൽപ്പന്നം ചേർക്കുക",
    total_items: "ആകെ ഇനങ്ങൾ",
    low_stock: "കുറഞ്ഞ സ്റ്റോക്ക്",
    out_of_stock: "സ്റ്റോക്ക് ഇല്ല",
    stock_value: "സ്റ്റോക്ക് മൂല്യം",
    search_placeholder: "കോഡ്, പേര് അല്ലെങ്കിൽ തരം അനുസരിച്ച് ഉൽപ്പന്നങ്ങൾ തിരയുക...",
    all_items: "എല്ലാ ഇനങ്ങളും",
    product_name: "ഉൽപ്പന്നത്തിന്റെ പേര്",
    product_code: "ഉൽപ്പന്ന കോഡ്",
    stock_status: "സ്റ്റോക്ക് നില",
    price: "വില",
    before_tax: "നികുതിക്ക് മുമ്പ്",
    actions: "പ്രവർത്തനങ്ങൾ",
    in_stock: "സ്റ്റോക്കുണ്ട്",
    units: "യൂണിറ്റുകൾ",
    delete_confirmation: "ഈ ഉൽപ്പന്നം നീക്കം ചെയ്യണോ?",
    no_products: "ഉൽപ്പന്നങ്ങളില്ല",
    no_products_desc: "ഉൽപ്പന്നങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
    edit_product: "ഉൽപ്പന്നം എഡിറ്റ് ചെയ്യുക",
    delete_product: "ഉൽപ്പന്നം നീക്കം ചെയ്യുക",
    loading_sample_data: "ലോഡുചെയ്യുന്നു... സാമ്പിൾ ഡാറ്റ കാണിക്കുന്നു"
  },
  business_settings_page: {
    business_settings: "ബിസിനസ്സ് ക്രമീകരണങ്ങൾ",
    manage_business_preferences: "നിങ്ങളുടെ ബിസിനസ്സ് മുൻഗണനകളും കോൺഫിഗറേഷനുകളും നിയന്ത്രിക്കുക",
    general_settings: "പൊതുവായ ക്രമീകരണങ്ങൾ",
    configure_general_settings: "അടിസ്ഥാന ബിസിനസ്സ് ക്രമീകരണങ്ങൾ കോൺഫിഗർ ചെയ്യുക",
    language: "ഭാഷ",
    currency: "കറൻസി",
    select_currency: "കറൻസി തിരഞ്ഞെടുക്കുക",
    timezone: "സമയമേഖല",
    select_timezone: "സമയമേഖല തിരഞ്ഞെടുക്കുക",
    notifications: "അറിയിപ്പുകൾ",
    manage_notification_preferences: "നിങ്ങളുടെ അറിയിപ്പ് മുൻഗണനകൾ നിയന്ത്രിക്കുക",
    low_stock_alerts: "കുറഞ്ഞ സ്റ്റോക്ക് മുന്നറിയിപ്പുകൾ",
    low_stock_description: "ഇൻവെന്ററി കുറവാകുമ്പോൾ അറിയിപ്പ് ലഭിക്കുക",
    expiring_items: "കാലഹരണപ്പെടുന്ന ഇനങ്ങൾ",
    expiring_items_description: "കാലഹരണപ്പെടുന്ന ഇനങ്ങളെക്കുറിച്ച് അറിയിപ്പ് ലഭിക്കുക",
    order_updates: "ഓർഡർ അപ്‌ഡേറ്റുകൾ",
    order_updates_description: "പുതിയ ഓർഡറുകളെക്കുറിച്ചും സ്റ്റാറ്റസ് മാറ്റങ്ങളെക്കുറിച്ചും അറിയിപ്പ് ലഭിക്കുക",
    saving: "സംരക്ഷിക്കുന്നു...",
    save_changes: "മാറ്റങ്ങൾ സംരക്ഷിക്കുക",
    failed_to_load_settings: "ക്രമീകരണങ്ങൾ ലോഡുചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    settings_saved_successfully: "ക്രമീകരണങ്ങൾ വിജയകരമായി സംരക്ഷിച്ചു",
    failed_to_save_settings: "ക്രമീകരണങ്ങൾ സംരക്ഷിക്കുന്നതിൽ പരാജയപ്പെട്ടു"
  },
  profile_settings: {
    title: 'ക്രമീകരണങ്ങൾ',
    description: 'നിങ്ങളുടെ അക്കൗണ്ടും പ്ലാറ്റ്‌ഫോം മുൻഗണനകളും നിയന്ത്രിക്കുക.',
    my_profile: 'എന്റെ പ്രൊഫൈൽ',
    my_profile_desc: 'വ്യക്തിഗത വിവരങ്ങളും അവതാറും',
    preferences: 'മുൻഗണനകൾ',
    preferences_desc: 'തീം, ഭാഷ, അറിയിപ്പുകൾ',
    security_privacy: 'സുരക്ഷയും സ്വകാര്യതയും',
    security_privacy_desc: 'പാസ്‌വേഡും ആക്‌സസ് സുരക്ഷയും',
    active_sessions: 'സജീവ സെഷനുകൾ',
    active_sessions_desc: 'ലോഗിൻ ചെയ്ത ഉപകരണങ്ങൾ നിയന്ത്രിക്കുക',
    sign_out: 'സൈൻ ഔട്ട്',
    profile_details: 'പ്രൊഫൈൽ വിശദാംശങ്ങൾ',
    profile_details_desc: 'നിങ്ങളുടെ ഫോട്ടോയും വ്യക്തിഗത വിവരങ്ങളും അപ്‌ഡേറ്റ് ചെയ്യുക.',
    verified_account: 'പരിശോധിച്ച അക്കൗണ്ട്',
    premium_plan: 'പ്രീമിയം പ്ലാൻ',
    first_name: 'ആദ്യ പേര്',
    last_name: 'അവസാന പേര്',
    email_address: 'ഇമെയിൽ വിലാസം',
    saving: 'സംരക്ഷിക്കുന്നു...',
    save_profile_changes: 'പ്രൊഫൈൽ മാറ്റങ്ങൾ സംരക്ഷിക്കുക',
    preferences_title: 'മുൻഗണനകൾ',
    preferences_page_desc: 'പ്ലാറ്റ്‌ഫോമിൽ നിങ്ങളുടെ അനുഭവം ഇഷ്ടാനുസൃതമാക്കുക.',
    appearance: 'രൂപം',
    theme: 'തീം',
    select_theme: 'തീം തിരഞ്ഞെടുക്കുക',
    light_mode: 'ലൈറ്റ് മോഡ്',
    dark_mode: 'ഡാർക്ക് മോഡ്',
    system_default: 'സിസ്റ്റം ഡിഫോൾട്ട്',
    display_language: 'ഡിസ്‌പ്ലേ ഭാഷ',
    select_language: 'ഭാഷ തിരഞ്ഞെടുക്കുക',
    notifications: 'അറിയിപ്പുകൾ',
    email_notifications: 'ഇമെയിൽ അറിയിപ്പുകൾ',
    email_notifications_desc: 'ഇമെയിൽ വഴി അപ്‌ഡേറ്റുകൾ ലഭിക്കുക',
    push_notifications: 'പുഷ് അറിയിപ്പുകൾ',
    push_notifications_desc: 'ബ്രൗസർ അറിയിപ്പുകൾ ലഭിക്കുക',
    sms_notifications: 'SMS അറിയിപ്പുകൾ',
    sms_notifications_desc: 'SMS വഴി അപ്‌ഡേറ്റുകൾ ലഭിക്കുക',
    save_preferences: 'മുൻഗണനകൾ സംരക്ഷിക്കുക',
    security_privacy_header: 'സുരക്ഷയും സ്വകാര്യതയും',
    security_privacy_header_desc: 'സുരക്ഷിതമായ പാസ്‌വേഡ് ഉപയോഗിച്ച് നിങ്ങളുടെ അക്കൗണ്ട് ശക്തിപ്പെടുത്തുക.',
    current_password: 'നിലവിലെ പാസ്‌വേഡ്',
    new_password: 'പുതിയ പാസ്‌വേഡ്',
    confirm_password: 'പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക',
    updating: 'അപ്‌ഡേറ്റ് ചെയ്യുന്നു...',
    change_password: 'പാസ്‌വേഡ് മാറ്റുക',
    advanced_security: 'വിപുലമായ സുരക്ഷ',
    advanced_security_desc: 'ഈ അക്കൗണ്ടിലേക്കുള്ള എല്ലാ ലോഗിൻ ശ്രമങ്ങൾക്കും മൾട്ടി-ഫാക്ടർ ഓതന്റിക്കേഷൻ ആവശ്യമാണ്.',
    enable_2fa: '2FA ഓതന്റിക്കേഷൻ പ്രവർത്തനക്ഷമമാക്കുക →',
    customization_underway: 'ഇഷ്ടാനുസൃതമാക്കൽ നടക്കുന്നു',
    customization_underway_desc: 'നിങ്ങളുടെ അനുഭവത്തിൽ നിങ്ങൾക്ക് പൂർണ്ണ നിയന്ത്രണം നൽകുന്നതിന് ഞങ്ങൾ സൂക്ഷ്മമായ അറിയിപ്പ് നിയന്ത്രണങ്ങളും ഉപകരണ മാനേജുമെന്റും നിർമ്മിക്കുന്നു.'
  },
  security_page: {
    hero_badge: "സുരക്ഷ",
    hero_title: "ബാങ്ക്-ഗ്രേഡ് സുരക്ഷ",
    hero_subtitle: "നിങ്ങളുടെ ബിസിനസ്സിനായി.",
    hero_desc: "നിങ്ങളുടെ ബിസിനസ്സ് ഡാറ്റ എന്റർപ്രൈസ്-ഗ്രേഡ് സുരക്ഷാ നടപടികൾ ഉപയോഗിച്ച് പരിരക്ഷിച്ചിരിക്കുന്നു. ഞങ്ങൾ സുരക്ഷയെ ഗൗരവമായി കാണുകയും നിങ്ങളുടെ ഡാറ്റ സുരക്ഷിതമായി സൂക്ഷിക്കാൻ തുടർച്ചയായി നിക്ഷേപിക്കുകയും ചെയ്യുന്നു.",
    measures_title: "ഞങ്ങളുടെ സുരക്ഷാ നടപടികൾ",
    measures_desc: "സുരക്ഷയുടെ ഒന്നിലധികം പാളികൾ ഓരോ തലത്തിലും നിങ്ങളുടെ ഡാറ്റ സംരക്ഷിക്കുന്നു."
  },
  subscription_page: {
  title: "സബ്സ്ക്രിപ്ഷൻ",
  subscription: "സബ്സ്ക്രിപ്ഷൻ",
  manage_subscription: "നിങ്ങളുടെ സബ്സ്ക്രിപ്ഷൻ പ്ലാനും ബില്ലിംഗ് വിവരങ്ങളും നിയന്ത്രിക്കുക.",
  current_plan: "നിലവിലെ പ്ലാൻ",
  gst_settings: "GST ക്രമീകരണങ്ങൾ",
  gst_settings_desc: "നിങ്ങളുടെ ബിസിനസ് അനുസരണത്തിനും ഇൻവോയ്സിംഗിനുമായി GST ക്രമീകരണങ്ങൾ നിയന്ത്രിക്കുകയും GST സവിശേഷതകൾ സജീവമാക്കുകയും ചെയ്യുക.",
  available_plans: "ലഭ്യമായ പ്ലാനുകൾ",
  plan_name: "പ്ലാൻ പേര്",
  free_tier: "സൗജന്യ പ്ലാൻ",
  included_features: "ഉൾപ്പെടുത്തിയ സവിശേഷതകൾ",
  no_active_subscription: "സജീവമായ സബ്സ്ക്രിപ്ഷൻ ഒന്നും കണ്ടെത്തിയില്ല.",
  loading: "ലോഡ് ചെയ്യുന്നു...",
  configure_gst: "GST ക്രമീകരിക്കുക",
  processing: "പ്രക്രിയയിൽ...",
  upgrade_plan: "പ്ലാൻ അപ്ഗ്രേഡ് ചെയ്യുക",
  error_fetch_subscription: "സബ്സ്ക്രിപ്ഷൻ വിവരങ്ങൾ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു.",
  error_generic_subscription: "സബ്സ്ക്രിപ്ഷൻ വിവരങ്ങൾ ലഭ്യമാക്കുന്നതിനിടെ ഒരു പിശക് സംഭവിച്ചു.",
  error_select_plan: "അപ്ഗ്രേഡ് ചെയ്യുന്നതിനായി ദയവായി ഒരു പ്ലാൻ തിരഞ്ഞെടുക്കുക.",
  success_upgrade: "സബ്സ്ക്രിപ്ഷൻ വിജയകരമായി അപ്ഗ്രേഡ് ചെയ്തു!",
  error_upgrade: "സബ്സ്ക്രിപ്ഷൻ അപ്ഗ്രേഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു.",
  error_upgrade_generic: "സബ്സ്ക്രിപ്ഷൻ അപ്ഗ്രേഡ് ചെയ്യുന്നതിനിടെ ഒരു പിശക് സംഭവിച്ചു.",
  error_business_not_found: "ബിസിനസ് പ്രൊഫൈൽ കണ്ടെത്തിയില്ല. ദയവായി ആദ്യം ഒന്ന് സൃഷ്ടിക്കുക.",
  error_fetch_business: "ബിസിനസ് വിവരങ്ങൾ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു.",
  upgrade: "അപ്ഗ്രേഡ്",
  billing_cycle: "ബില്ലിംഗ് ചക്രം",
  next_payment: "അടുത്ത പേയ്മെന്റ്",
  payment_method: "പേയ്മെന്റ് രീതി",
  invoices: "ഇൻവോയ്സുകൾ",
  download: "ഡൗൺലോഡ്",
  status: "സ്ഥിതി",
  active: "സജീവം",
  inactive: "നിഷ്ക്രിയ",
  canceled: "റദ്ദാക്കി",
  features: "സവിശേഷതകൾ",
  monthly: "പ്രതിമാസം",
  yearly: "പ്രതിവർഷം",
  save_20: "20% ലാഭിക്കുക"
},

  purchases_page: {
    purchases: "വാങ്ങലുകൾ",
    manage_purchases: "നിങ്ങളുടെ വാങ്ങലുകളും പേയ്മെന്റുകളും നിയന്ത്രിക്കുക",
    add_purchase: "വാങ്ങൽ ചേർക്കുക",
    total_purchases: "ആകെ വാങ്ങലുകൾ",
    total_spent: "ആകെ ചെലവഴിച്ചത്",
    pending_purchases: "തീർപ്പുകൽപ്പിക്കാത്ത വാങ്ങലുകൾ",
    pending_payment: "തീർപ്പുകൽപ്പിക്കാത്ത പേയ്മെന്റ്",
    search_placeholder: "വിതരണക്കാരന്റെ പേര് അല്ലെങ്കിൽ വാങ്ങൽ ഐഡി ഉപയോഗിച്ച് തിരയുക...",
    all: "എല്ലാം",
    pending: "തീർപ്പുകൽപ്പിക്കാത്തത്",
    unpaid: "പണം നൽകാത്തത്",
    no_purchases: "വാങ്ങലുകളൊന്നുമില്ല",
    no_purchases_desc: "വാങ്ങലുകളൊന്നും കണ്ടെത്തിയില്ല",
    id_date: "ഐഡി / തീയതി",
    supplier: "വിതരണക്കാരൻ",
    amount: "തുക",
    before_tax: "നികുതിക്ക് മുമ്പ്",
    status: "അവസ്ഥ",
    payment_status: "പേയ്മെന്റ് നില",
    actions: "പ്രവർത്തനങ്ങൾ",
    delete_confirmation: "ഈ വാങ്ങൽ നീക്കം ചെയ്യണോ?",
    paid: "പണം നൽകി",
    partial: "ഭാഗികം"
  },
  suppliers_page: {
    suppliers: "വിതരണക്കാർ",
    manage_suppliers: "നിങ്ങളുടെ വിതരണക്കാരെയും വെണ്ടർമാരെയും നിയന്ത്രിക്കുക",
    add_supplier: "വിതരണക്കാരനെ ചേർക്കുക",
    total_suppliers: "ആകെ വിതരണക്കാർ",
    active_suppliers: "സജീവ വിതരണക്കാർ",
    total_purchases: "ആകെ വാങ്ങലുകൾ",
    pending_payments: "തീർപ്പുകൽപ്പിക്കാത്ത പേയ്മെന്റുകൾ",
    search_placeholder: "പേര്, ഇമെയിൽ അല്ലെങ്കിൽ ഫോൺ വഴി വിതരണക്കാരെ തിരയുക...",
    all: "എല്ലാം",
    active: "സജീവം",
    inactive: "നിഷ്ക്രിയ",
    no_suppliers: "വിതരണക്കാരില്ല",
    no_suppliers_desc: "വിതരണക്കാരെ ആരെയും കണ്ടെത്തിയില്ല",
    supplier: "വിതരണക്കാരൻ",
    contact: "ബന്ധപ്പെടുക",
    gstin: "GSTIN",
    status: "അവസ്ഥ",
    actions: "പ്രവർത്തനങ്ങൾ",
    edit: "എഡിറ്റ്",
    delete: "നീക്കം ചെയ്യുക",
    delete_confirmation: "ഈ വിതരണക്കാരനെ നീക്കം ചെയ്യണോ?",
    name: "പേര്",
    enter_name: "വിതരണക്കാരന്റെ പേര് നൽകുക",
    phone: "ഫോൺ",
    enter_phone: "ഫോൺ നമ്പർ നൽകുക",
    email: "ഇമെയിൽ",
    enter_email: "ഇമെയിൽ വിലാസം നൽകുക",
    gstin_placeholder: "GSTIN നൽകുക",
    address: "വിലാസം",
    enter_address: "വിലാസം നൽകുക",
    cancel: "റദ്ദാക്കുക",
    add: "ചേർക്കുക",
    save: "സംരക്ഷിക്കുക"
  },
  gst_page: {
    gst_filing: "ജിഎസ്ടി ഫയലിംഗ്",
    manage_gst: "നിങ്ങളുടെ ജിഎസ്ടി റിട്ടേണുകളും ഫയലിംഗുകളും നിയന്ത്രിക്കുക",
    file_return: "റിട്ടേൺ ഫയൽ ചെയ്യുക",
    gst_summary: "ജിഎസ്ടി സംഗ്രഹം",
    gstr1: "GSTR-1",
    gstr3b: "GSTR-3B",
    input_tax_credit: "ഇൻപുട്ട് ടാക്സ് ക്രെഡിറ്റ്",
    tax_liability: "നികുതി ബാധ്യത",
    filing_history: "ഫയലിംഗ് ചരിത്രം",
    upcoming_deadlines: "വരാനിരിക്കുന്ന സമയപരിധികൾ",
    financial_year: "സാമ്പത്തിക വർഷം",
    quarter: "ത്രൈമാസികം",
    month: "മാസം",
    status: "അവസ്ഥ",
    filed: "ഫയൽ ചെയ്തു",
    pending: "തീർപ്പുകൽപ്പിക്കാത്തത്",
    overdue: "കാലഹരണപ്പെട്ടത്",
    download_report: "റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യുക",
    view_details: "വിശദാംശങ്ങൾ കാണുക"
  },
  customers_page: {
    customers: "ഉപഭോക്താക്കൾ",
    manage_customers: "നിങ്ങളുടെ ഉപഭോക്തൃ അടിത്തറ നിയന്ത്രിക്കുക",
    add_customer: "ഉപഭോക്താവിനെ ചേർക്കുക",
    total_customers: "ആകെ ഉപഭോക്താക്കൾ",
    new_this_month: "ഈ മാസം പുതിയത്",
    active_customers: "സജീവ ഉപഭോക്താക്കൾ",
    total_revenue: "ആകെ വരുമാനം",
    search_placeholder: "പേര്, ഇമെയിൽ അല്ലെങ്കിൽ ഫോൺ വഴി തിരയുക...",
    all: "എല്ലാം",
    active: "സജീവം",
    inactive: "നിഷ്ക്രിയ",
    no_customers: "ഉപഭോക്താക്കളില്ല",
    no_customers_desc: "ഉപഭോക്താക്കളെ ആരെയും കണ്ടെത്തിയില്ല",
    customer: "ഉപഭോക്താവ്",
    contact: "ബന്ധപ്പെടുക",
    orders: "ഓർഡറുകൾ",
    spent: "ചെലവഴിച്ചത്",
    status: "അവസ്ഥ",
    actions: "പ്രവർത്തനങ്ങൾ",
    edit: "എഡിറ്റ്",
    delete: "നീക്കം ചെയ്യുക",
    delete_confirmation: "ഈ ഉപഭോക്താവിനെ നീക്കം ചെയ്യണോ?",
    name: "പേര്",
    enter_name: "ഉപഭോക്താവിന്റെ പേര് നൽകുക",
    phone: "ഫോൺ",
    enter_phone: "ഫോൺ നമ്പർ നൽകുക",
    email: "ഇമെയിൽ",
    enter_email: "ഇമെയിൽ വിലാസം നൽകുക",
    address: "വിലാസം",
    enter_address: "വിലാസം നൽകുക",
    cancel: "റദ്ദാക്കുക",
    add: "ചേർക്കുക",
    save: "സംരക്ഷിക്കുക"
  },
  billing_page: {
    title: "സാമ്പത്തികവും ബില്ലിംഗും",
    subtitle: "കോർപ്പറേറ്റ് സബ്‌സ്‌ക്രിപ്‌ഷനുകൾക്കും റിസോഴ്‌സ് സെറ്റിൽമെന്റുകൾക്കുമുള്ള ആർക്കിടെക്ചർ",
    tabs: {
      subscription: "സബ്‌സ്‌ക്രിപ്‌ഷൻ",
      history: "ചരിത്രം",
      settlements: "സെറ്റിൽമെന്റുകൾ",
      corporate_profile: "കോർപ്പറേറ്റ് പ്രൊഫൈൽ"
    },
    subscription: {
      tier_status: "ടയർ നില",
      authenticated: "ആധികാരികമാക്കി",
      renewal: "പുതുക്കൽ: ",
      ascend_plan: "പ്ലാൻ അപ്‌ഗ്രേഡ് ചെയ്യുക",
      equilibrium_method: "ഇക്വിലിബ്രിയം രീതി",
      recent_settlement: "സമീപകാല സെറ്റിൽമെന്റ്",
      verified: "പരിശോധിച്ചു"
    },
    history: {
      invoice_identifier: "ഇൻവോയ്സ് ഐഡന്റിഫയർ",
      issuance_date: "ഇഷ്യു തീയതി",
      settlement_amount: "സെറ്റിൽമെന്റ് തുക",
      status: "നില",
      actions: "പ്രവർത്തനങ്ങൾ",
      no_history_title: "സെറ്റിൽമെന്റ് ചരിത്രമില്ല",
      no_history_desc: "ആധികാരികമാക്കലിന് ശേഷം നിങ്ങളുടെ പരിശോധിച്ച ഇൻവോയ്സുകൾ ഇവിടെ ദൃശ്യമാകും."
    },
    settlements: {
      architecture_title: "സെറ്റിൽമെന്റ് ആർക്കിടെക്ചർ",
      architecture_desc: "അംഗീകൃത കോർപ്പറേറ്റ് ആക്സസ് പോയിന്റുകൾ",
      initialize_method: "രീതി ആരംഭിക്കുക",
      no_vectors: "സെറ്റിൽമെന്റ് വെക്റ്ററുകളൊന്നും തിരിച്ചറിഞ്ഞില്ല"
    },
    profile: {
      corporate_identity: "കോർപ്പറേറ്റ് ഐഡന്റിറ്റി",
      tax_protocol: "ടാക്സ് പ്രോട്ടോക്കോൾ / GSTIN",
      registered_address: "രജിസ്റ്റർ ചെയ്ത വിലാസം",
      metropolis: "നഗരം",
      jurisdiction: "അധികാരപരിധി",
      postal_code: "പിൻ കോഡ്",
      sovereignty: "പരമാധികാരം",
      synchronizing: "സമന്വയിപ്പിക്കുന്നു...",
      authorize_updates: "അപ്‌ഡേറ്റുകൾ അംഗീകരിക്കുക",
      update_success: "ബില്ലിംഗ് വിവരങ്ങൾ വിജയകരമായി അപ്‌ഡേറ്റുചെയ്‌തു"
    }
  },
  locations_page: {
    title: "ലൊക്കേഷനുകൾ",
    subtitle: "ഒന്നിലധികം ലൊക്കേഷനുകളും സ്റ്റോക്ക് കൈമാറ്റങ്ങളും നിയന്ത്രിക്കുക",
    transfer_stock: "സ്റ്റോക്ക് കൈമാറ്റം",
    add_location: "ലൊക്കേഷൻ ചേർക്കുക",
    total_locations: "ലൊക്കേഷനുകൾ",
    active_locations: "സജീവ ലൊക്കേഷനുകൾ",
    total_stock: "ആകെ സ്റ്റോക്ക്",
    transfers_progress: "പുരോഗതിയിലുള്ള കൈമാറ്റങ്ങൾ",
    tabs: {
      locations: "ലൊക്കേഷനുകൾ",
      all_stock: "എല്ലാ ലൊക്കേഷൻ സ്റ്റോക്കുകളും",
      transfers: "സ്റ്റോക്ക് കൈമാറ്റങ്ങൾ",
      analytics: "അനലിറ്റിക്സ്"
    },
    table: {
      location_name: "ലൊക്കേഷൻ പേര്",
      type: "തരം",
      address: "വിലാസം",
      contact: "കോൺടാക്റ്റ്",
      status: "നില",
      actions: "പ്രവർത്തനങ്ങൾ",
      active: "സജീവം",
      inactive: "നിഷ്ക്രിയം",
      store: "സ്റ്റോർ",
      warehouse: "വെയർഹൗസ്",
      view_details: "വിശദാംശങ്ങൾ കാണുക",
      edit: "എഡിറ്റ്",
      delete: "നീക്കം ചെയ്യുക"
    },
    transfer_table: {
      date: "കൈമാറ്റ തീയതി",
      date_label: "തീയതി",
      route: "മുതൽ → വരെ"
    },
    empty_state: {
      no_locations: "ലൊക്കേഷനുകളൊന്നും കണ്ടെത്തിയില്ല",
      no_locations_desc: "നിങ്ങൾ ഇതുവരെ ലൊക്കേഷനുകളൊന്നും ചേർത്തിട്ടില്ല. ആരംഭിക്കുന്നതിന് ഒരു സ്റ്റോറോ വെയർഹൗസോ ചേർക്കുക.",
      no_transfers: "കൈമാറ്റങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
      no_transfers_desc: "നിങ്ങൾ ഇതുവരെ സ്റ്റോക്ക് കൈമാറ്റങ്ങളൊന്നും ആരംഭിച്ചിട്ടില്ല.",
      no_stock: "സ്റ്റോക്ക് ഡാറ്റയില്ല",
      no_stock_desc: "തിരഞ്ഞെടുത്ത ലൊക്കേഷന് സ്റ്റോക്ക് ഡാറ്റയൊന്നും ലഭ്യമല്ല."
    },
    analytics: {
      sales_analysis: "വിൽപ്പന വിശകലനം",
      coming_soon: "വിപുലമായ അനലിറ്റിക്സ് ഉടൻ വരുന്നു."
    }
  },
  usage_page: {
    title: "ഉപയോഗവും പരിധികളും",
    subtitle: "നിങ്ങളുടെ ഉപയോഗവും പരിധികളും കാണുക",
    export_report: "റിപ്പോർട്ട് എക്‌സ്‌പോർട്ടുചെയ്യുക",
    cards: {
      api_calls: "API കോളുകൾ",
      storage_used: "സ്റ്റോറേജ് ഉപയോഗം",
      data_transfer: "ഡാറ്റാ കൈമാറ്റം",
      processing_time: "പ്രോസസ്സിംഗ് സമയം"
    },
    tabs: {
      system_status: "സിസ്റ്റം നില",
      usage_limits: "ഉപയോഗ പരിധികൾ",
      usage_history: "ഉപയോഗ ചരിത്രം",
      alerts: "മുന്നറിയിപ്പുകൾ"
    },
    monitor: {
      system_health: "സിസ്റ്റം ആരോഗ്യം",
      current_system_status: "നിലവിലെ സിസ്റ്റം നില",
      uptime: "അപ്‌ടൈം",
      response_time: "പ്രതികരണ സമയം",
      errors: "പിശകുകൾ",
      database_usage: "ഡാറ്റാബേസ് ഉപയോഗം",
      auto_scaling: "ഓട്ടോ സ്കെയിലിംഗ്",
      system_running_smoothly: "സിസ്റ്റം സുഗമമായി പ്രവർത്തിക്കുന്നു.",
      system_running_desc: "ഉപയോഗത്തെ അടിസ്ഥാനമാക്കി സിസ്റ്റം വിഭവങ്ങൾ സ്വയമേവ കൈകാര്യം ചെയ്യുന്നു. വേഗത്തിലുള്ള പ്രകടനത്തിനായി സിസ്റ്റം നന്നായി പ്രവർത്തിക്കുന്നു.",
      manage_auto_scaling: "ഓട്ടോ സ്കെയിലിംഗ് നിയന്ത്രിക്കുക"
    },
    quotas: {
      usage_limit: "ഉപയോഗ പരിധി",
      used: "ഉപയോഗിച്ചു",
      total_limit: "ആകെ പരിധി"
    },
    history: {
      date: "തീയതി",
      api_calls: "API കോളുകൾ",
      storage: "സ്റ്റോറേജ്",
      data_transfer: "ഡാറ്റാ കൈമാറ്റം",
      reqs: "അഭ്യർത്ഥനകൾ",
      no_history: "ചരിത്രമില്ല",
      no_history_desc: "ഉപയോഗ ചരിത്രം ഇവിടെ ദൃശ്യമാകും"
    },
    alerts: {
      fix_issue: "പ്രശ്നം പരിഹരിക്കുക",
      all_systems_good: "എല്ലാ സിസ്റ്റങ്ങളും മികച്ചതാണ്",
      no_issues_found: "പ്രശ്നങ്ങളൊന്നും കണ്ടെത്തിയില്ല"
    }
  },
  sidebar: {
    menu: {
      overview: "അവലോകനം",
      business: "ബിസിനസ്സ്",
      finance: "ധനകാര്യം",
      system: "സിസ്റ്റം"
    },
    items: {
      dashboard: "ഡാഷ്‌ബോർഡ്",
      analytics: "അനലിറ്റിക്സ്",
      business_profile: "ബിസിനസ്സ് പ്രൊഫൈൽ",
      inventory: "ഇൻവെന്ററി",
      orders: "ഓർഡറുകൾ",
      purchases: "വാങ്ങലുകൾ",
      customers: "ഉപഭോക്താക്കൾ",
      suppliers: "വിതരണക്കാർ",
      business_settings: "ബിസിനസ്സ് ക്രമീകരണങ്ങൾ",
      tax_gst: "നികുതി & GST",
      billing: "ബില്ലിംഗ്",
      subscription: "സബ്സ്ക്രിപ്ഷൻ",
      locations: "ലൊക്കേഷനുകൾ",
      settings: "ക്രമീകരണങ്ങൾ",
      usage: "ഉപയോഗം"
    },
    footer: {
      upgrade_pro: "Pro-ലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക",
      account: "അക്കൗണ്ട്",
      billing: "ബില്ലിംഗ്",
      notifications: "അറിയിപ്പുകൾ",
      logout: "ലോഗ് ഔട്ട്"
    }
  },
  business: {
    profile: 'ബിസിനസ് പ്രൊഫൈൽ',
    edit_profile: 'പ്രൊഫൈൽ എഡിറ്റുചെയ്യുക',
    go_back: 'തിരികെ പോകുക',
    not_provided: 'നൽകിയിട്ടില്ല',
    fetch_profile_error: 'ബിസിനസ് പ്രൊഫൈൽ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു',
    business_label: 'ബിസിനസ്',
    flower_vendor: 'പൂക്കച്ചവടക്കാരൻ',
    grocery_store: 'പലചരക്ക് കട',
    textile_shop: 'തുണിക്കട',
    hardware_store: 'ഹാർഡ്‌വെയർ സ്റ്റോർ',
    electronics_shop: 'ഇലക്ട്രോണിക്സ് കട',
    other: 'മറ്റുള്ളവ',
    email: 'ഇമെയിൽ',
    phone: 'ഫോൺ',
    address: 'വിലാസം',
    category: 'വിഭാഗം',
    annual_turnover: 'വാർഷിക വിറ്റുവരവ്',
    gst_registered: 'ജിഎസ്ടി രജിസ്റ്റർ ചെയ്തോ',
    yes: 'അതെ',
    no: 'ഇല്ല',
    gst_number: 'ജിഎസ്ടി നമ്പർ',
    registration_date: 'രജിസ്ട്രേഷൻ തീയതി',
    n_a: 'ലഭ്യമല്ല',
    no_profile_found: 'ബിസിനസ് പ്രൊഫൈൽ കണ്ടെത്തിയില്ല',
    no_business_profile_description: 'നിങ്ങൾ ഇതുവരെ നിങ്ങളുടെ ബിസിനസ് പ്രൊഫൈൽ സജ്ജീകരിച്ചിട്ടില്ല. എല്ലാ ഫീച്ചറുകളും അൺലോക്ക് ചെയ്യാൻ ഒന്ന് ഉണ്ടാക്കുക.',
    create_business_profile: 'ബിസിനസ് പ്രൊഫൈൽ ഉണ്ടാക്കുക',
    edit_business_profile: 'ബിസിനസ് പ്രൊഫൈൽ എഡിറ്റുചെയ്യുക',
    basic_info: 'അടിസ്ഥാന വിവരങ്ങൾ',
    business_name: 'ബിസിനസ്സിന്റെ പേര്',
    business_type: 'ബിസിനസ്സിന്റെ തരം',
    retailer: 'ചില്ലറ വ്യാപാരി',
    wholesaler: 'മൊത്തക്കച്ചവടക്കാരൻ',
    manufacturer: 'നിർമ്മാതാവ്',
    service_provider: 'സേവന ദാതാവ്',
    turnover_range_0_5L: '₹0 - ₹5 ലക്ഷം',
    turnover_range_5L_20L: '₹5 ലക്ഷം - ₹20 ലക്ഷം',
    turnover_range_20L_1Cr: '₹20 ലക്ഷം - ₹1 കോടി',
    turnover_range_1Cr_plus: '₹1 കോടിക്ക് മുകളിൽ',
    fetch_gst_error: 'ജിഎസ്ടി ക്രമീകരണങ്ങൾ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു',
    toggle_gst_error: 'ജിഎസ്ടി ഫീച്ചറുകൾ ടോഗിൾ ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
    update_gst_status_error: 'ജിഎസ്ടി സ്റ്റാറ്റസ് അപ്ഡേറ്റ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
    save_error: 'മാറ്റങ്ങൾ സേവ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
    profile_updated: 'പ്രൊഫൈൽ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു',
    error_saving: 'സേവ് ചെയ്യുമ്പോൾ ഒരു പിശക് സംഭവിച്ചു',
    business_profile_not_found: 'ബിസിനസ് പ്രൊഫൈൽ കണ്ടെത്തിയില്ല.',
    placeholders: {
      enter_business_name: 'ബിസിനസ്സിന്റെ പേര് നൽകുക',
      select_business_type: 'ബിസിനസ്സിന്റെ തരം തിരഞ്ഞെടുക്കുക',
      enter_email: 'business@example.com',
      enter_phone: '+91 98765 43210',
      enter_address: 'പൂർണ്ണമായ വിലാസം നൽകുക',
      select_category: 'വിഭാഗം തിരഞ്ഞെടുക്കുക',
      select_turnover_range: 'വിറ്റുവരവ് പരിധി തിരഞ്ഞെടുക്കുക',
      enter_gstin: '22AAAAA0000A1Z5',
    },
    gst_configuration: 'ജിഎസ്ടി കോൺഫിഗറേഷൻ',
    enabled: 'പ്രവർത്തനക്ഷമമാക്കി',
    disabled: 'പ്രവർത്തനരഹിതമാക്കി',
    gstin_number: 'ജിഎസ്ടിൻ നമ്പർ',
    gstin_placeholder: '22AAAAA0000A1Z5',
    gst_registration_date: 'ജിഎസ്ടി രജിസ്റ്റർ ചെയ്തതിന്റെ തീയതി',
    default_cgst: 'ഡിഫോൾട്ട് സിജിഎസ്ടി (%)',
    default_sgst: 'ഡിഫോൾട്ട് എസ്ജിഎസ്ടി (%)',
    default_igst: 'ഡിഫോൾട്ട് ഐജിഎസ്ടി (%)',
    auto_sync: 'ജിഎസ്ടി പോർട്ടലുമായി ഇൻവോയ്സുകൾ ഓട്ടോ-സിങ്ക് ചെയ്യുക',
    cancel: 'റദ്ദാക്കുക',
    saving: 'സേവ് ചെയ്യുന്നു...',
    save_changes: 'മാറ്റങ്ങൾ സേവ് ചെയ്യുക',
  }
};